var $n = Object.defineProperty;
var Hn = (e, t, r) => t in e ? $n(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var De = (e, t, r) => Hn(e, typeof t != "symbol" ? t + "" : t, r);
import { isRef as Ln, ref as Un, computed as Y } from "vue";
import { defineStore as ru, storeToRefs as jn } from "pinia";
var he;
(function(e) {
  e[e.rgb = 0] = "rgb", e[e.rgba = 1] = "rgba", e[e.hsl = 2] = "hsl", e[e.hsla = 3] = "hsla", e[e.hex = 4] = "hex", e[e.yuv = 5] = "yuv", e[e.str = 6] = "str";
})(he || (he = {}));
class E {
  constructor(t = null, r = null, u = null, n = null, i = 1) {
    if (this.hexContainer = null, this.rgbContainer = null, this.hslContainer = null, this.yuvContainer = null, this.toString = () => this.hslContainer ? this.cssHSLA : this.rgbContainer ? this.cssRGBA : this.hexContainer ? this.cssHex : this.cssHSLA, !(t || r || u || n))
      throw new Error("One component must be set");
    t ? this.hexContainer = t : r ? this.rgbContainer = {
      r: r.r,
      g: r.g,
      b: r.b
    } : u ? this.hslContainer = {
      h: u.h,
      s: u.s,
      l: u.l
    } : n && (this.yuvContainer = {
      y: n.y,
      u: n.u,
      v: n.v
    }), this.alpha = i;
  }
  /**
   * Create a color from a hex string, with or without leading #
   */
  static fromHex(t) {
    let r = E.normalizeHex(t);
    if (!r)
      throw new Error("Invalid hex value: " + t);
    return new E(r, null, null, null, 1);
  }
  /**
   * Create a color from an RGB object
   */
  static fromRGB(t, r = 1) {
    return new E(null, t, null, null, r);
  }
  /**
   * Create a color from an HSL object
   */
  static fromHSL(t, r = 1) {
    return new E(null, null, t, null, r);
  }
  /**
   * Create a color from an YUV object
   */
  static fromYUV(t, r = 1) {
    return new E(null, null, null, t, r);
  }
  /**
   * Create a color object from a string
   * Supported notations:
   *  - hex (with or without #)
   *  - rgb(), rgba()
   *  - hsl(), hsla()
   *
   * @param {string} str
   * @returns {Color}
   */
  static fromString(t) {
    if (t === null)
      return null;
    if (t instanceof E)
      return t;
    let r = E.detectType(t), u;
    switch (r) {
      case he.hex:
        return E.fromHex(t);
      case he.hsl:
        return u = t.match(/hsl\(([\d.]+), ?([\d.]+)%, ?([\d.]+)%\)/), u ? E.fromHSL({
          h: parseInt(u[1]) % 360 / 360,
          s: parseFloat(u[2]) / 100,
          l: parseFloat(u[3]) / 100
        }) : null;
      case he.hsla:
        return u = t.match(/hsla\(([\d.]+), ?([\d.]+)%, ?([\d.]+)%, ?([\d.]+%?)\)/), u ? E.fromHSL({
          h: parseInt(u[1]) % 360 / 360,
          s: parseFloat(u[2]) / 100,
          l: parseFloat(u[3]) / 100
        }, this.parseAlpha(u[4])) : null;
      case he.rgb:
        return u = t.match(/rgb\((\d+), ?(\d+), ?(\d+)\)/), u ? E.fromRGB({
          r: parseInt(u[1]),
          g: parseInt(u[2]),
          b: parseInt(u[3])
        }) : null;
      case he.rgba:
        return u = t.match(/rgba\((\d+), ?(\d+), ?(\d+), ?([\d.]+%?)\)/), u ? E.fromRGB({
          r: parseInt(u[1]),
          g: parseInt(u[2]),
          b: parseInt(u[3])
        }, this.parseAlpha(u[4])) : null;
      default:
        return null;
    }
  }
  /**
   * Parse a numeric string or percentage into a number
   * e.g.: "0.1", "10%" -> 0.1
   */
  static parseAlpha(t) {
    return t.endsWith("%") ? parseFloat(t.substring(0, t.length - 1)) / 100 : parseFloat(t);
  }
  /**
   * Get a random color (RGB 0, 0, 0 to RGB 255, 255, 255)
   *
   * @returns {Color}
   */
  static random() {
    let t = Math.round(Math.random() * 255), r = Math.round(Math.random() * 255), u = Math.round(Math.random() * 255);
    return E.fromRGB({
      r: t,
      g: r,
      b: u
    });
  }
  // Operations
  /**
   * Darken the color by a certain percentage (0-100), just like in SCSS
   */
  darken(t) {
    return E.fromHSL({
      h: this.hsl.h,
      s: this.hsl.s,
      l: Math.max(Math.min(this.hsl.l - t / 100, 1), 0)
    }, this.alpha);
  }
  /**
   * Lighten the color by a certain percentage (0-100), just like in SCSS
   */
  lighten(t) {
    return this.darken(-t);
  }
  /**
   * Check if this color is lighter than the passed color
   */
  isLighterThan(t) {
    return this.perceivedBrightness > t.perceivedBrightness;
  }
  /**
   * Check if this color is darker than the passed color
   */
  isDarkerThan(t) {
    return this.perceivedBrightness < t.perceivedBrightness;
  }
  /**
   * Saturate the color by a certain percentage (0-100), just like in SCSS
   */
  saturate(t) {
    return E.fromHSL({
      h: this.hsl.h,
      s: Math.max(Math.min(this.hsl.s + t / 100, 1), 0),
      l: this.hsl.l
    }, this.alpha);
  }
  /**
   * Desaturate the color by a certain percentage (0-100), just like in SCSS
   */
  desaturate(t) {
    return this.saturate(-t);
  }
  /**
   * Shift the hue by an amount between 0-1
   */
  shiftHue(t) {
    return E.fromHSL({
      h: E.modulo(this.hsl.h + t, 1),
      s: this.hsl.s,
      l: this.hsl.l
    }, this.alpha);
  }
  /**
   * Get a clone of this color with an alpha value between 0 and 1
   */
  withAlpha(t = 1) {
    let r = this.clone();
    return r.alpha = t, r;
  }
  /**
   * Get a clone of this color with a specific hue between 0 and 1
   */
  withHue(t = 0) {
    let r = this.clone();
    return r.hsl.h = t, r.rgbContainer = null, r.hexContainer = null, r;
  }
  /**
   * Get a clone of this color with a specific saturation between 0 and 1
   */
  withSaturation(t = 1) {
    let r = this.clone();
    return r.hsl.s = t, r.rgbContainer = null, r.hexContainer = null, r;
  }
  /**
   * Get a clone of this color with a specific lightness between 0 and 1
   */
  withLightness(t = 1) {
    let r = this.clone();
    return r.hsl.l = t, r;
  }
  /**
   * Mix this color with another color
   *
   * @param {Color} color     Other color
   * @param {number} weight   Weight between 0 and 100, like SCSS
   *
   * @returns {Color}
   */
  mixWith(t, r = 50) {
    return E.mix(this, t, r);
  }
  /**
   * Get the WCAG contrast ratio to another color
   */
  contrastTo(t) {
    return E.contrast(this, t);
  }
  /**
   * Clone this color
   */
  clone() {
    return E.fromHSL(this.hsl, this.alpha);
  }
  /**
   * Return the perceived brightness
   * The perceived brightness is the brightness value between 0 and 255
   * as perceived by a human in RGB colorspace with alpha = 1.
   */
  get perceivedBrightness() {
    return 0.2126 * this.rgb.r + 0.7152 * this.rgb.g + 0.0722 * this.rgb.b;
  }
  /**
   * Is this color darker than a defined limit according to human perception?
   */
  isDark() {
    return this.perceivedBrightness <= 120;
  }
  /**
   * Is this color lighter than a defined limit according to human perception?
   */
  isLight() {
    return !this.isDark();
  }
  /**
   * Does the color look red to a human?
   */
  isRedish() {
    let t = this.hsl.h, r = this.hsl.s, u = this.hsl.l;
    return u < 0.2 || u >= 0.96 ? !1 : t >= 0 && t <= 0.072 || t >= 0.933 ? r > 0.201 : !1;
  }
  /**
   * Does the color look green to a human?
   */
  isGreenish() {
    let t = this.hsl.h, r = this.hsl.s, u = this.hsl.l;
    return u < 0.2 || u >= 0.96 ? !1 : t >= 0.23 && t <= 0.469 ? r > 0.201 : !1;
  }
  /**
   * Is this color white?
   */
  isWhite() {
    return (this.hsl.s == 1 || this.hsl.s == 0) && this.hsl.l == 1;
  }
  /**
   * Is this color black?
   */
  isBlack() {
    return (this.hsl.s == 1 || this.hsl.s == 0) && this.hsl.l == 0;
  }
  /**
   * Is this color similar to another color?
   *
   * @param {Color}   color       Color to compare to
   * @param {number}  accuracy    How close the colors have to be, 0-1
   *
   * @returns {boolean}
   */
  isSimilarTo(t, r = 0.99) {
    return E.areSimilar(this, t, r);
  }
  // Getters
  /**
   * Get as hex string without leading #
   */
  get hex() {
    return this.hexContainer || this.calculateHex(), this.hexContainer;
  }
  /**
   * Get as a CSS-suitable hex string
   */
  get cssHex() {
    return "#" + this.hex;
  }
  /**
   * Get as RGB object
   */
  get rgb() {
    return this.rgbContainer || this.calculateRGB(), this.rgbContainer;
  }
  /**
   * Get as a CSS-suitable rgba string
   */
  get cssRGBA() {
    return "rgba(" + this.rgb.r + ", " + this.rgb.g + ", " + this.rgb.b + ", " + this.alpha + ")";
  }
  /**
   * Get the RGB values as a numbers array [R, G, B]
   */
  get rgbArray() {
    return [
      this.rgb.r,
      this.rgb.g,
      this.rgb.b
    ];
  }
  /**
   * Get the RGB values as a string "R, G, B"
   * Useful e.g. for v-bind in Vite, like this:
   * rgba(v-bind("someColor.rgbString"), 0.5)
   */
  get rgbString() {
    const t = this.rgb;
    return `${t.r}, ${t.g}, ${t.b}`;
  }
  /**
   * Get as HSL object
   */
  get hsl() {
    return this.hslContainer || this.calculateHSL(), this.hslContainer;
  }
  /**
   * Get as a CSS-suitable hsla string
   */
  get cssHSLA() {
    return "hsla(" + Math.round(this.hsl.h * 360 * 1e4) / 1e4 + ", " + Math.round(this.hsl.s * 100 * 1e4) / 1e4 + "%, " + Math.round(this.hsl.l * 100 * 1e4) / 1e4 + "%, " + this.alpha + ")";
  }
  /**
   * Get the HSL values as a numbers array [H, S, L]
   */
  get hslArray() {
    return [
      this.hsl.h,
      this.hsl.s,
      this.hsl.l
    ];
  }
  /**
   * Get as YUV object
   */
  get yuv() {
    return this.yuvContainer || this.calculateYUV(), this.yuvContainer;
  }
  // Calculators
  calculateHex() {
    if (!this.hexContainer)
      if (this.rgbContainer)
        this.hexContainer = E.rgbToHex(this.rgbContainer);
      else if (this.hslContainer)
        this.rgbContainer = E.hslToRgb(this.hslContainer), this.calculateHex();
      else
        throw new Error("Could not calculate hex value");
  }
  calculateRGB() {
    if (!this.rgbContainer)
      if (this.hexContainer)
        this.rgbContainer = E.hexToRgb(this.hexContainer);
      else if (this.hslContainer)
        this.rgbContainer = E.hslToRgb(this.hslContainer);
      else
        throw new Error("Could not calculate RGB values");
  }
  calculateHSL() {
    if (!this.hslContainer)
      if (this.hexContainer)
        this.hslContainer = E.hexToHsl(this.hexContainer);
      else if (this.rgbContainer)
        this.hslContainer = E.rgbToHsl(this.rgbContainer);
      else
        throw new Error("Could not calculate HSL values");
  }
  calculateYUV() {
    this.yuvContainer || (this.rgbContainer || this.calculateRGB(), this.yuvContainer = E.rgbToYuv(this.rgbContainer));
  }
  // Static
  /**
   * Mix two colors like SCSS' mix() function, ignores alpha completely
   *
   * @param {Color}   color1  Hex Color 1
   * @param {Color}   color2  Hex Color 2
   * @param {number}  weight  Percentage from 0 to 100
   */
  static mix(t, r, u = 50) {
    let n = "";
    for (let s = 0; s <= 5; s += 2) {
      let o = parseInt(t.hex.substring(s, s + 2), 16), l = parseInt(r.hex.substring(s, s + 2), 16), c = Math.floor(l + (o - l) * (u / 100)), f = c.toString(16);
      for (; f.length < 2; )
        f = "0" + f;
      n += f;
    }
    const i = r.alpha + (t.alpha - r.alpha) * (u / 100);
    return E.fromHex(n).withAlpha(i);
  }
  /**
   * Shade blend two colors with a given percentage
   * Thanks to http://stackoverflow.com/a/13542669/1486930 for this piece of code.
   * Ignores alpha.
   *
   * @param {Number}  p   Percentage to blend, negative means darken, positive means lighten
   * @param {Color}   c0  Color to blend
   * @param {Color}   c1  Color to blend in, optional
   */
  static shadeBlend(t, r, u) {
    let n = t < 0 ? t * -1 : t, i = Math.round, s = parseInt, o = s(r.hex.slice(1), 16), l = s((u ? u.hex : t < 0 ? "#000000" : "#FFFFFF").slice(1), 16), c = o >> 16, f = o >> 8 & 255, p = o & 255;
    return E.fromHex((16777216 + (i(((l >> 16) - c) * n) + c) * 65536 + (i(((l >> 8 & 255) - f) * n) + f) * 256 + (i(((l & 255) - p) * n) + p)).toString(16).slice(1));
  }
  /**
   * Get the WCAG contrast ratio between two colors
   */
  static contrast(t, r) {
    const u = t.perceivedBrightness, n = r.perceivedBrightness, i = Math.max(u, n), s = Math.min(u, n);
    return (i + 0.05) / (s + 0.05);
  }
  /**
   * Normalize a hex color into a 6-digit hex value without leading hash symbol
   */
  static normalizeHex(t) {
    if (!t || !t.length || t.match(/[G-Zg-z]+/))
      return null;
    let r = t;
    if (r.charAt(0) == "#" && (r = r.substring(1, r.length), r.charAt(0) == "#") || r.length < 2)
      return null;
    if (r.length == 2) {
      let u = r.charAt(0), n = r.charAt(1);
      r = u + n + u + n + u + n;
    } else if (r.length == 3) {
      let u = r.charAt(0), n = r.charAt(1), i = r.charAt(2);
      r = u + u + n + n + i + i;
    } else if (r.length != 6)
      return null;
    return r;
  }
  /**
   * Check whether two colors are similar to each other, based on their YUV representation
   *
   * @param {Color}   color1
   * @param {Color}   color2
   * @param {number}  accuracy    How close the colors have to be, 0-1
   *
   * @returns {boolean}
   */
  static areSimilar(t, r, u = 0.99) {
    const n = Math.abs(t.yuv.y - r.yuv.y), i = Math.abs(t.yuv.u - r.yuv.u), s = Math.abs(t.yuv.v - r.yuv.v), o = 1 - u;
    return n <= o && i <= o && s <= o;
  }
  /**
   * Convert this color into an object for use as JSON
   * Uses whatever format is available in this priority:
   * - HSLA
   * - RGBA
   * - Hex
   *
   * Use {@link Color.fromJSON} to restore from JSON
   */
  toJSON() {
    return this.rgbContainer ? {
      ...this.rgb,
      alpha: this.alpha
    } : this.hslContainer ? {
      ...this.hsl,
      alpha: this.alpha
    } : {
      hex: this.hex
    };
  }
  /**
   * Restore an instance of {@link Color} from a JSON object created by {@link Color.toJSON}
   */
  static fromJSON(t) {
    if (!t)
      return null;
    let r;
    return typeof t == "string" ? r = JSON.parse(t) : r = t, r.hex ? E.fromHex(r.hex) : r.h ? E.fromHSL(r, r.alpha) : r.r ? E.fromRGB(r, r.alpha) : null;
  }
  /* CONVERTERS */
  /**
   * Convert RGB to HSL
   */
  static rgbToHsl(t) {
    let { r, g: u, b: n } = t;
    r /= 255, u /= 255, n /= 255;
    let i = Math.max(r, u, n), s = Math.min(r, u, n), o, l, c = (i + s) / 2;
    if (i == s)
      o = l = 0;
    else {
      let f = i - s;
      switch (l = c > 0.5 ? f / (2 - i - s) : f / (i + s), i) {
        case r:
          o = (u - n) / f + (u < n ? 6 : 0);
          break;
        case u:
          o = (n - r) / f + 2;
          break;
        case n:
          o = (r - u) / f + 4;
          break;
      }
      o /= 6;
    }
    return { h: o, s: l, l: c };
  }
  /**
   * Convert rgb to a hex string without leading #
   */
  static rgbToHex(t) {
    return t.r.toString(16).padStart(2, "0") + t.g.toString(16).padStart(2, "0") + t.b.toString(16).padStart(2, "0");
  }
  /**
   * Convert hex (with or without leading #) to HSL
   */
  static hexToHsl(t) {
    if (!t)
      return {
        h: 0,
        s: 0,
        l: 0
      };
    let r = E.hexToRgb(t);
    return E.rgbToHsl(r);
  }
  /**
   * Convert HSL to RGB
   */
  static hslToRgb(t) {
    let r, u, n;
    if (t.s == 0)
      r = u = n = t.l;
    else {
      let i = (l, c, f) => (f < 0 && (f += 1), f > 1 && (f -= 1), f < 0.16666666666666666 ? l + (c - l) * 6 * f : f < 0.5 ? c : f < 0.6666666666666666 ? l + (c - l) * (0.6666666666666666 - f) * 6 : l), s = t.l < 0.5 ? t.l * (1 + t.s) : t.l + t.s - t.l * t.s, o = 2 * t.l - s;
      r = i(o, s, t.h + 1 / 3), u = i(o, s, t.h), n = i(o, s, t.h - 1 / 3);
    }
    return {
      r: Math.round(r * 255),
      g: Math.round(u * 255),
      b: Math.round(n * 255)
    };
  }
  /**
   * Convert hex (with or without leading #) to RGB
   */
  static hexToRgb(t) {
    return t.charAt(0) == "#" && (t = t.substring(1)), {
      r: parseInt(t.substring(0, 2), 16),
      g: parseInt(t.substring(2, 4), 16),
      b: parseInt(t.substring(4, 6), 16)
    };
  }
  /**
   * Convert YUV to RGB
   * Thanks to https://stackoverflow.com/a/17934865/1486930
   */
  static yuvToRgb(t) {
    let { y: r, u, v: n } = t;
    return r -= 16, u -= 128, n -= 128, {
      r: Math.abs(Math.round((1.164 * r + 1.596 * n) * 255)),
      g: Math.abs(Math.round((1.164 * r - 0.392 * u - 0.813 * n) * 255)),
      b: Math.abs(Math.round((1.164 * r + 2.017 * u) * 255))
    };
  }
  /**
   * Convert RGB to YUV
   * Thanks to https://stackoverflow.com/a/17934865/1486930
   */
  static rgbToYuv(t) {
    let { r, g: u, b: n } = t;
    return r /= 255, u /= 255, n /= 255, {
      y: 0.257 * r + 0.504 * u + 0.098 * n + 16,
      u: -0.148 * r - 0.291 * u + 0.439 * n + 128,
      v: 0.439 * r - 0.368 * u - 0.071 * n + 128
    };
  }
  /**
   * Detect the type of color of a string
   *
   * @param {string | undefined | null} str
   *
   * @returns {ColorType}
   */
  static detectType(t) {
    if (t == null)
      return null;
    let r = String(t), u = r.length >= 3 ? r.substring(0, 3) : "", n = r.length >= 4 ? r.substring(0, 4) : "";
    return E.normalizeHex(r) ? he.hex : n === "rgba" ? he.rgba : u === "rgb" ? he.rgb : n === "hsla" ? he.hsla : u === "hsl" ? he.hsl : he.str;
  }
  static modulo(t, r) {
    return (t % r + r) % r;
  }
}
E.PERCEIVED_BRIGHTNESS_THRESHOLD = 155;
E.WHITE = E.fromHex("#ffffff");
E.BLACK = E.fromHex("#000000");
E.TRANSPARENT = E.fromHSL({ h: 0, s: 0, l: 0 }, 0);
String.prototype.padStart || (String.prototype.padStart = function(t, r) {
  return t = t >> 0, r = String(typeof r < "u" ? r : " "), this.length > t ? String(this) : (t = t - this.length, t > r.length && (r += r.repeat(t / r.length)), r.slice(0, t) + String(this));
});
const Pn = ".accent,.blue{color:#136cc6}.dark-blue{color:#0a3561}.red{color:#f44336}.red-2{color:#e53935}.red-3{color:#d32f2f}.dark-red{color:#c62828}.pink{color:#e91e63}.magenta{color:#f0f}.purple{color:#9c27b0}.purple-2{color:#8e24aa}.purple-3{color:#7b1fa2}.deep-purple{color:#673ab7}.deep-purple-2{color:#5e35b1}.deep-purple-3{color:#512da8}.indigo{color:#3f51b5}.cyan{color:#00bcd4}.teal{color:#009688}.green{color:#4caf50}.green-2{color:#43a047}.green-3{color:#388e3c}.light-green{color:#8bc34a}.light-green-2{color:#7cb342}.light-green-3{color:#689f38}.lime{color:#cddc39}.yellow{color:#ffeb3b}.amber{color:#ffc107}.orange{color:#ffa000}.deep-orange{color:#ff5722}.brown{color:#795548}.grey{color:#9e9e9e}.dark-grey{color:#5a5a5a}.light-grey{color:#999}.light-grey-blue,.lightgreyblue{color:#717e8e}.blue-grey{color:#607d8b}.black{color:#000}.white{color:#fff}.secondary{color:#999}.dark{color:#111}.box-background-light{color:#fff}.box-border-light{color:#e7e8eb}.border-light{color:#e2e2e2}.border-dark{color:#3e4357}.disabled-state-light{color:#bfc3c7}.component-disabled-background{color:#f2f2f2}.component-disabled-text{color:#333}.box-background-dark{color:#191923}.box-background-secondary-light{color:#f6f7f9}.box-border-dark{color:#3e4357}.seperator-border-light{color:#f3f3f5}.seperator-border-dark{color:#303044}.text-light{color:#eaedf1}.text-secondary-light{color:#717e8e}.text-dark{color:#111}.button-background-light-disabled{color:#dcddde}.checkbox-border-light{color:#9eadc0}.login-background-dark{color:#091521}.login-background-light{color:#f9fafb}.input-border-light{color:#b4bfce}.input-border-hover-light{color:#98a9bd}.input-border-dark{color:#56566f}.table-heading-background-light{color:#eaedf1}.dummy-background-light{color:#d7d8d8}.dummy-color-light{color:#a5a7a9}.bankID{color:#4a78b1}.info{color:#039be5}.code-pink{color:#f92672}.code-green{color:#a5e22f}.code-yellow{color:#e6db74}.code-orange{color:#fd9720}.code-purple{color:#ae81ff}.code-blue{color:#65d9ef}.code-grey{color:#5c6273}.light-background{color:#f9fafb}.border{color:red}.dark-border{color:#add8e6}.dark-box-background{color:#000}.dark-selection-background,.dark-hover-background{color:pink}";
var vt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ve(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var dt = { exports: {} };
dt.exports;
var $r;
function Yn() {
  return $r || ($r = 1, function(e, t) {
    var r = 200, u = "__lodash_hash_undefined__", n = 9007199254740991, i = "[object Arguments]", s = "[object Array]", o = "[object Boolean]", l = "[object Date]", c = "[object Error]", f = "[object Function]", p = "[object GeneratorFunction]", m = "[object Map]", N = "[object Number]", _ = "[object Object]", b = "[object Promise]", F = "[object RegExp]", v = "[object Set]", I = "[object String]", B = "[object Symbol]", H = "[object WeakMap]", x = "[object ArrayBuffer]", R = "[object DataView]", z = "[object Float32Array]", G = "[object Float64Array]", q = "[object Int8Array]", U = "[object Int16Array]", $ = "[object Int32Array]", J = "[object Uint8Array]", ee = "[object Uint8ClampedArray]", T = "[object Uint16Array]", C = "[object Uint32Array]", g = /[\\^$.*+?()[\]{}|]/g, S = /\w*$/, y = /^\[object .+?Constructor\]$/, M = /^(?:0|[1-9]\d*)$/, A = {};
    A[i] = A[s] = A[x] = A[R] = A[o] = A[l] = A[z] = A[G] = A[q] = A[U] = A[$] = A[m] = A[N] = A[_] = A[F] = A[v] = A[I] = A[B] = A[J] = A[ee] = A[T] = A[C] = !0, A[c] = A[f] = A[H] = !1;
    var L = typeof vt == "object" && vt && vt.Object === Object && vt, W = typeof self == "object" && self && self.Object === Object && self, P = L || W || Function("return this")(), K = t && !t.nodeType && t, te = K && !0 && e && !e.nodeType && e, de = te && te.exports === K;
    function ie(a, D) {
      return a.set(D[0], D[1]), a;
    }
    function Ee(a, D) {
      return a.add(D), a;
    }
    function ae(a, D) {
      for (var d = -1, O = a ? a.length : 0; ++d < O && D(a[d], d, a) !== !1; )
        ;
      return a;
    }
    function X(a, D) {
      for (var d = -1, O = D.length, ne = a.length; ++d < O; )
        a[ne + d] = D[d];
      return a;
    }
    function h(a, D, d, O) {
      for (var ne = -1, oe = a ? a.length : 0; ++ne < oe; )
        d = D(d, a[ne], ne, a);
      return d;
    }
    function w(a, D) {
      for (var d = -1, O = Array(a); ++d < a; )
        O[d] = D(d);
      return O;
    }
    function j(a, D) {
      return a == null ? void 0 : a[D];
    }
    function ue(a) {
      var D = !1;
      if (a != null && typeof a.toString != "function")
        try {
          D = !!(a + "");
        } catch {
        }
      return D;
    }
    function re(a) {
      var D = -1, d = Array(a.size);
      return a.forEach(function(O, ne) {
        d[++D] = [ne, O];
      }), d;
    }
    function Ce(a, D) {
      return function(d) {
        return a(D(d));
      };
    }
    function ye(a) {
      var D = -1, d = Array(a.size);
      return a.forEach(function(O) {
        d[++D] = O;
      }), d;
    }
    var we = Array.prototype, Ge = Function.prototype, lt = Object.prototype, Vt = P["__core-js_shared__"], gr = function() {
      var a = /[^.]+$/.exec(Vt && Vt.keys && Vt.keys.IE_PROTO || "");
      return a ? "Symbol(src)_1." + a : "";
    }(), Cr = Ge.toString, Le = lt.hasOwnProperty, Ct = lt.toString, Su = RegExp(
      "^" + Cr.call(Le).replace(g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Er = de ? P.Buffer : void 0, yr = P.Symbol, br = P.Uint8Array, _u = Ce(Object.getPrototypeOf, Object), Tu = Object.create, Ou = lt.propertyIsEnumerable, Iu = we.splice, Ar = Object.getOwnPropertySymbols, Mu = Er ? Er.isBuffer : void 0, xu = Ce(Object.keys, Object), Gt = rt(P, "DataView"), Dt = rt(P, "Map"), Wt = rt(P, "Promise"), qt = rt(P, "Set"), Qt = rt(P, "WeakMap"), ct = rt(Object, "create"), Nu = Qe(Gt), Ru = Qe(Dt), ku = Qe(Wt), $u = Qe(qt), Hu = Qe(Qt), vr = yr ? yr.prototype : void 0, wr = vr ? vr.valueOf : void 0;
    function We(a) {
      var D = -1, d = a ? a.length : 0;
      for (this.clear(); ++D < d; ) {
        var O = a[D];
        this.set(O[0], O[1]);
      }
    }
    function Lu() {
      this.__data__ = ct ? ct(null) : {};
    }
    function Uu(a) {
      return this.has(a) && delete this.__data__[a];
    }
    function ju(a) {
      var D = this.__data__;
      if (ct) {
        var d = D[a];
        return d === u ? void 0 : d;
      }
      return Le.call(D, a) ? D[a] : void 0;
    }
    function Pu(a) {
      var D = this.__data__;
      return ct ? D[a] !== void 0 : Le.call(D, a);
    }
    function Yu(a, D) {
      var d = this.__data__;
      return d[a] = ct && D === void 0 ? u : D, this;
    }
    We.prototype.clear = Lu, We.prototype.delete = Uu, We.prototype.get = ju, We.prototype.has = Pu, We.prototype.set = Yu;
    function Te(a) {
      var D = -1, d = a ? a.length : 0;
      for (this.clear(); ++D < d; ) {
        var O = a[D];
        this.set(O[0], O[1]);
      }
    }
    function zu() {
      this.__data__ = [];
    }
    function Vu(a) {
      var D = this.__data__, d = Et(D, a);
      if (d < 0)
        return !1;
      var O = D.length - 1;
      return d == O ? D.pop() : Iu.call(D, d, 1), !0;
    }
    function Gu(a) {
      var D = this.__data__, d = Et(D, a);
      return d < 0 ? void 0 : D[d][1];
    }
    function Wu(a) {
      return Et(this.__data__, a) > -1;
    }
    function qu(a, D) {
      var d = this.__data__, O = Et(d, a);
      return O < 0 ? d.push([a, D]) : d[O][1] = D, this;
    }
    Te.prototype.clear = zu, Te.prototype.delete = Vu, Te.prototype.get = Gu, Te.prototype.has = Wu, Te.prototype.set = qu;
    function et(a) {
      var D = -1, d = a ? a.length : 0;
      for (this.clear(); ++D < d; ) {
        var O = a[D];
        this.set(O[0], O[1]);
      }
    }
    function Qu() {
      this.__data__ = {
        hash: new We(),
        map: new (Dt || Te)(),
        string: new We()
      };
    }
    function Zu(a) {
      return yt(this, a).delete(a);
    }
    function Ku(a) {
      return yt(this, a).get(a);
    }
    function Ju(a) {
      return yt(this, a).has(a);
    }
    function Xu(a, D) {
      return yt(this, a).set(a, D), this;
    }
    et.prototype.clear = Qu, et.prototype.delete = Zu, et.prototype.get = Ku, et.prototype.has = Ju, et.prototype.set = Xu;
    function tt(a) {
      this.__data__ = new Te(a);
    }
    function en() {
      this.__data__ = new Te();
    }
    function tn(a) {
      return this.__data__.delete(a);
    }
    function rn(a) {
      return this.__data__.get(a);
    }
    function un(a) {
      return this.__data__.has(a);
    }
    function nn(a, D) {
      var d = this.__data__;
      if (d instanceof Te) {
        var O = d.__data__;
        if (!Dt || O.length < r - 1)
          return O.push([a, D]), this;
        d = this.__data__ = new et(O);
      }
      return d.set(a, D), this;
    }
    tt.prototype.clear = en, tt.prototype.delete = tn, tt.prototype.get = rn, tt.prototype.has = un, tt.prototype.set = nn;
    function sn(a, D) {
      var d = Jt(a) || On(a) ? w(a.length, String) : [], O = d.length, ne = !!O;
      for (var oe in a)
        Le.call(a, oe) && !(ne && (oe == "length" || Bn(oe, O))) && d.push(oe);
      return d;
    }
    function Br(a, D, d) {
      var O = a[D];
      (!(Le.call(a, D) && Or(O, d)) || d === void 0 && !(D in a)) && (a[D] = d);
    }
    function Et(a, D) {
      for (var d = a.length; d--; )
        if (Or(a[d][0], D))
          return d;
      return -1;
    }
    function an(a, D) {
      return a && Sr(D, Xt(D), a);
    }
    function Zt(a, D, d, O, ne, oe, Oe) {
      var le;
      if (O && (le = oe ? O(a, ne, oe, Oe) : O(a)), le !== void 0)
        return le;
      if (!bt(a))
        return a;
      var xr = Jt(a);
      if (xr) {
        if (le = An(a), !D)
          return En(a, le);
      } else {
        var ut = qe(a), Nr = ut == f || ut == p;
        if (Mn(a))
          return dn(a, D);
        if (ut == _ || ut == i || Nr && !oe) {
          if (ue(a))
            return oe ? a : {};
          if (le = vn(Nr ? {} : a), !D)
            return yn(a, an(le, a));
        } else {
          if (!A[ut])
            return oe ? a : {};
          le = wn(a, ut, Zt, D);
        }
      }
      Oe || (Oe = new tt());
      var Rr = Oe.get(a);
      if (Rr)
        return Rr;
      if (Oe.set(a, le), !xr)
        var kr = d ? bn(a) : Xt(a);
      return ae(kr || a, function(er, At) {
        kr && (At = er, er = a[At]), Br(le, At, Zt(er, D, d, O, At, a, Oe));
      }), le;
    }
    function on(a) {
      return bt(a) ? Tu(a) : {};
    }
    function ln(a, D, d) {
      var O = D(a);
      return Jt(a) ? O : X(O, d(a));
    }
    function Dn(a) {
      return Ct.call(a);
    }
    function cn(a) {
      if (!bt(a) || _n(a))
        return !1;
      var D = Mr(a) || ue(a) ? Su : y;
      return D.test(Qe(a));
    }
    function fn(a) {
      if (!Tr(a))
        return xu(a);
      var D = [];
      for (var d in Object(a))
        Le.call(a, d) && d != "constructor" && D.push(d);
      return D;
    }
    function dn(a, D) {
      if (D)
        return a.slice();
      var d = new a.constructor(a.length);
      return a.copy(d), d;
    }
    function Kt(a) {
      var D = new a.constructor(a.byteLength);
      return new br(D).set(new br(a)), D;
    }
    function hn(a, D) {
      var d = D ? Kt(a.buffer) : a.buffer;
      return new a.constructor(d, a.byteOffset, a.byteLength);
    }
    function pn(a, D, d) {
      var O = D ? d(re(a), !0) : re(a);
      return h(O, ie, new a.constructor());
    }
    function Fn(a) {
      var D = new a.constructor(a.source, S.exec(a));
      return D.lastIndex = a.lastIndex, D;
    }
    function mn(a, D, d) {
      var O = D ? d(ye(a), !0) : ye(a);
      return h(O, Ee, new a.constructor());
    }
    function gn(a) {
      return wr ? Object(wr.call(a)) : {};
    }
    function Cn(a, D) {
      var d = D ? Kt(a.buffer) : a.buffer;
      return new a.constructor(d, a.byteOffset, a.length);
    }
    function En(a, D) {
      var d = -1, O = a.length;
      for (D || (D = Array(O)); ++d < O; )
        D[d] = a[d];
      return D;
    }
    function Sr(a, D, d, O) {
      d || (d = {});
      for (var ne = -1, oe = D.length; ++ne < oe; ) {
        var Oe = D[ne], le = void 0;
        Br(d, Oe, le === void 0 ? a[Oe] : le);
      }
      return d;
    }
    function yn(a, D) {
      return Sr(a, _r(a), D);
    }
    function bn(a) {
      return ln(a, Xt, _r);
    }
    function yt(a, D) {
      var d = a.__data__;
      return Sn(D) ? d[typeof D == "string" ? "string" : "hash"] : d.map;
    }
    function rt(a, D) {
      var d = j(a, D);
      return cn(d) ? d : void 0;
    }
    var _r = Ar ? Ce(Ar, Object) : Rn, qe = Dn;
    (Gt && qe(new Gt(new ArrayBuffer(1))) != R || Dt && qe(new Dt()) != m || Wt && qe(Wt.resolve()) != b || qt && qe(new qt()) != v || Qt && qe(new Qt()) != H) && (qe = function(a) {
      var D = Ct.call(a), d = D == _ ? a.constructor : void 0, O = d ? Qe(d) : void 0;
      if (O)
        switch (O) {
          case Nu:
            return R;
          case Ru:
            return m;
          case ku:
            return b;
          case $u:
            return v;
          case Hu:
            return H;
        }
      return D;
    });
    function An(a) {
      var D = a.length, d = a.constructor(D);
      return D && typeof a[0] == "string" && Le.call(a, "index") && (d.index = a.index, d.input = a.input), d;
    }
    function vn(a) {
      return typeof a.constructor == "function" && !Tr(a) ? on(_u(a)) : {};
    }
    function wn(a, D, d, O) {
      var ne = a.constructor;
      switch (D) {
        case x:
          return Kt(a);
        case o:
        case l:
          return new ne(+a);
        case R:
          return hn(a, O);
        case z:
        case G:
        case q:
        case U:
        case $:
        case J:
        case ee:
        case T:
        case C:
          return Cn(a, O);
        case m:
          return pn(a, O, d);
        case N:
        case I:
          return new ne(a);
        case F:
          return Fn(a);
        case v:
          return mn(a, O, d);
        case B:
          return gn(a);
      }
    }
    function Bn(a, D) {
      return D = D ?? n, !!D && (typeof a == "number" || M.test(a)) && a > -1 && a % 1 == 0 && a < D;
    }
    function Sn(a) {
      var D = typeof a;
      return D == "string" || D == "number" || D == "symbol" || D == "boolean" ? a !== "__proto__" : a === null;
    }
    function _n(a) {
      return !!gr && gr in a;
    }
    function Tr(a) {
      var D = a && a.constructor, d = typeof D == "function" && D.prototype || lt;
      return a === d;
    }
    function Qe(a) {
      if (a != null) {
        try {
          return Cr.call(a);
        } catch {
        }
        try {
          return a + "";
        } catch {
        }
      }
      return "";
    }
    function Tn(a) {
      return Zt(a, !0, !0);
    }
    function Or(a, D) {
      return a === D || a !== a && D !== D;
    }
    function On(a) {
      return In(a) && Le.call(a, "callee") && (!Ou.call(a, "callee") || Ct.call(a) == i);
    }
    var Jt = Array.isArray;
    function Ir(a) {
      return a != null && xn(a.length) && !Mr(a);
    }
    function In(a) {
      return Nn(a) && Ir(a);
    }
    var Mn = Mu || kn;
    function Mr(a) {
      var D = bt(a) ? Ct.call(a) : "";
      return D == f || D == p;
    }
    function xn(a) {
      return typeof a == "number" && a > -1 && a % 1 == 0 && a <= n;
    }
    function bt(a) {
      var D = typeof a;
      return !!a && (D == "object" || D == "function");
    }
    function Nn(a) {
      return !!a && typeof a == "object";
    }
    function Xt(a) {
      return Ir(a) ? sn(a) : fn(a);
    }
    function Rn() {
      return [];
    }
    function kn() {
      return !1;
    }
    e.exports = Tn;
  }(dt, dt.exports)), dt.exports;
}
var zn = Yn();
const Vn = /* @__PURE__ */ ve(zn);
function* Gn() {
  for (; ; )
    yield `0x${Math.random().toString(16).slice(2, 16)}`;
}
const ht = class ht {
  constructor(t, r = Gn()) {
    this.knownObjects = t, this.keyGenerator = r;
  }
  /**
   * Get a shared instance
   *
   * @returns {ObjectKeyedMemory}
   */
  static get shared() {
    return ht.sharedInstance;
  }
  /**
   * Add something to the memory and return the key it was assigned
   * If the object existed already, the same key will be returned.
   *
   * @param sth
   *
   * @returns {string}
   */
  add(t) {
    if (this.hasObject(t))
      return this.getKeyOf(t);
    const r = this.keyGenerator.next().value;
    return this.knownObjects.set(t, r), r;
  }
  /**
   * Check if memory has a specific object
   *
   * @param sth
   *
   * @returns {boolean}
   */
  hasObject(t) {
    return this.knownObjects.has(t);
  }
  /**
   * Check if memory has a specific key
   *
   * @param {string} key
   *
   * @returns {boolean}
   */
  hasKey(t) {
    for (let r of this.knownObjects.values())
      if (r == t)
        return !0;
    return !1;
  }
  /**
   * Get the key for an object if it is known
   *
   * @param sth
   *
   * @returns {string | null}
   */
  getKeyOf(t) {
    return this.knownObjects.has(t) ? this.knownObjects.get(t) : null;
  }
  /**
   * Remove an object
   *
   * @param sth
   *
   * @returns {this}
   */
  removeObject(t) {
    return this.hasObject(t) && this.knownObjects.delete(t), this;
  }
  /**
   * Remove an object by its key
   *
   * @param {string} key
   *
   * @returns {this}
   */
  removeKey(t) {
    for (let r of this.knownObjects.entries())
      if (r[1] == t)
        return this.knownObjects.delete(r[0]), this;
    return this;
  }
};
De(ht, "sharedInstance", new ht(/* @__PURE__ */ new Map()));
let ir = ht;
const Ta = (e, t = 300) => {
  let r;
  return (...u) => {
    clearTimeout(r), r = setTimeout(() => {
      e.apply(null, u);
    }, t);
  };
}, Oa = (e, t) => (r, u) => e(r, u) ? -1 : t(r, u) ? 1 : 0, Ia = (e, t = !1) => (r, u) => {
  const n = r[e], i = u[e];
  let s = typeof n, o = typeof i;
  if (s != o)
    throw new Error("Incompatible types: " + s + ", " + o);
  return typeof n == "string" ? t ? i.localeCompare(n) : n.localeCompare(i) : typeof n == "number" ? n < i ? t ? 1 : -1 : n > i ? t ? -1 : 1 : 0 : 0;
}, Ma = (e, ...t) => new Promise((r, u) => {
  try {
    r(e(...t));
  } catch (n) {
    u(n);
  }
}), Hr = () => {
  const e = new ir(/* @__PURE__ */ new Map());
  return (t, r) => {
    if (typeof r == "object" && r !== null) {
      if (e.hasObject(r))
        return "* duplicate object *";
      e.add(r);
    }
    return r;
  };
}, xa = (e) => new Promise((t) => setTimeout(t, e)), Wn = (e) => {
  let t = e;
  return Ln(e) ? Wn(t.value) : t;
}, wt = (e) => e, uu = (e) => () => wt(e), tr = (e) => e != null, Ne = (e, t) => {
  if (e == null)
    return null;
  const r = Vn(e);
  if (t) {
    const u = t(r);
    if (u)
      return u;
  }
  return r;
}, Na = (e) => {
  const t = typeof e;
  if (t == "number" || t == "boolean")
    return !1;
  if (e == null)
    return !0;
  if (typeof e.length < "u")
    return e.length == 0;
  for (let r in e)
    if (e.hasOwnProperty(r))
      return !1;
  return !1;
}, qn = (e, t) => JSON.stringify(e, Hr()) == JSON.stringify(t, Hr()), Qn = (e) => String(e).split(`
`).map((t) => t.split("@")), Ra = () => {
  let e = Qn(new Error().stack);
  e.shift(), console.debug("%c[Stacktrace]", "color:orange");
  for (let t of e) {
    let r = t[1] ? t[1].split(":") : ["?", "?", "?", "?"];
    console.debug("	%c" + t[0] + " %cat %c" + r[0] + ":" + r[1] + " :" + r[2] + ":" + r[3], "color:cyan", "color:grey", "color:grey");
  }
}, ka = (e, t, r, u) => (e /= u / 2, e < 1 ? r / 2 * e * e + t : (e--, -r / 2 * (e * (e - 2) - 1) + t)), $a = (e) => {
  let t = document.createElement("style");
  return t.appendChild(document.createTextNode("")), t.innerHTML = e, document.head.appendChild(t), t;
}, nu = (e, t) => e ? t(e) ? !0 : e.parentElement ? nu(e.parentElement, t) : !1 : !1, Ha = (e, t) => nu(e, (r) => {
  for (let u of t)
    if (r.classList.contains(u))
      return !0;
  return !1;
}), La = async (e) => {
  try {
    if (typeof navigator.clipboard > "u")
      throw new Error("The clipboard API is not supported by this browser.");
    await navigator.clipboard.writeText(e);
  } catch (t) {
    if (!Zn(e))
      throw t;
    return !0;
  }
}, Zn = (e) => {
  let t = document.createElement("textarea");
  t.style.position = "fixed", t.style.top = 0, t.style.left = 0, t.style.width = "2em", t.style.height = "2em", t.style.padding = 0, t.style.border = "none", t.style.outline = "none", t.style.boxShadow = "none", t.style.background = "transparent", t.value = e, document.body.appendChild(t), t.select();
  let r;
  try {
    r = document.execCommand("copy");
  } catch {
    r = !1;
  }
  return document.body.removeChild(t), r;
}, Ua = async () => {
  if (typeof navigator > "u")
    throw new Error("Browser APIs unavailable.");
  if (typeof ClipboardItem > "u")
    throw new Error("The Clipboard API is not supported by this browser.");
  try {
    if (typeof navigator.permissions < "u" && navigator.permissions.query) {
      let e = null;
      try {
        e = await navigator.permissions.query({
          name: "clipboard-read"
        });
      } catch (t) {
        if (Kn() || Jn())
          try {
            e = await navigator.permissions.query({
              name: "clipboardRead"
            });
          } catch {
          }
        else
          throw t;
      }
      if ((e == null ? void 0 : e.state) === "denied") {
        console.info("[readFromClipboard]", "Clipboard access denied");
        return;
      }
    }
    return await navigator.clipboard.read();
  } catch (e) {
    throw console.warn("[readFromClipboard]", "Could not access clipboard", e), e;
  }
}, ja = async (e, t) => await (await e.getType(t)).arrayBuffer(), Pa = async (e) => await (await e.getType("text/plain")).text(), Kn = () => navigator.userAgent.toLowerCase().includes("firefox") || "netscape" in window && / rv:/.test(navigator.userAgent), Jn = () => !!(navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent && navigator.userAgent.indexOf("CriOS") == -1 && navigator.userAgent.indexOf("FxiOS") == -1), Xn = ru("acquisit-ui-branding", {
  state: uu({
    color: {
      primary: null,
      secondary: null
    },
    logo: {
      primary: null,
      secondary: null
    }
  }),
  actions: {
    setColors(e, t) {
      this.color.primary = e, this.color.secondary = t;
    },
    setLogos(e, t) {
      this.logo.primary = e, this.logo.secondary = t;
    }
  }
});
class Ht {
  constructor(t, r, u) {
    this.prefix = t, this.color = r, this.muted = u;
  }
  log(...t) {
    this.call("log", this.prefix, t);
  }
  logFrom(t, ...r) {
    this.call("log", this.prefix + ", " + t, r);
  }
  debug(...t) {
    this.call("debug", this.prefix, t);
  }
  debugFrom(t, ...r) {
    this.call("debug", this.prefix + ", " + t, r);
  }
  error(...t) {
    this.call("error", this.prefix, t);
  }
  errorFrom(t, ...r) {
    this.call("error", this.prefix + ", " + t, r);
  }
  info(...t) {
    this.call("info", this.prefix, t);
  }
  infoFrom(t, ...r) {
    this.call("info", this.prefix + ", " + t, r);
  }
  warn(...t) {
    this.call("warn", this.prefix, t);
  }
  warnFrom(t, ...r) {
    this.call("warn", this.prefix + ", " + t, r);
  }
  call(t, r, u) {
    this.muted || (this.color ? u.unshift("%c[" + r + "]", "color:" + this.color) : u.unshift("[" + r + "]"), console[t](...u));
  }
  section(t) {
    return new Ht(this.prefix + ", " + t, this.color, this.muted);
  }
}
class su extends Ht {
  constructor(r, u) {
    let n = typeof window > "u" || !window.DEBUG;
    super(r, u, n);
    De(this, "always");
    this.prefix = r, this.color = u, this.always = new Ht(r, u, !1);
  }
}
const Fe = function(e, t = null) {
  if (e instanceof URL) {
    const r = e.pathname.split("/");
    let u;
    r.length < 2 ? u = e.pathname : u = r[r.length - 2] + "/" + r[r.length - 1], e = u;
  }
  return new su(e, t);
}, Ya = function(e, t) {
  return new su(e + ":" + (t.uid ?? "–"), Fe.COLOR_COMPONENT);
};
Fe.COLOR_STORE = "orange";
Fe.COLOR_VALUE_HANDLER = "orange";
Fe.COLOR_VALIDATOR = "orange";
Fe.COLOR_COMPONENT = "cyan";
Fe.COLOR_HELPER = "#0099CC";
Fe.COLOR_BACKEND = "#888";
Fe.COLOR_LIB = "purple";
const es = Fe("helpers/color"), ts = () => {
  const e = new RegExp(".([a-zA-Z0-9-]+) ?{\\n?(	| {2})?color: ?(.*?);?\\n?}", "gm"), t = Pn.replace(e, "$1:$3|"), r = t.split("|");
  let u = {};
  for (let n of r) {
    let [i, s] = n.split(":");
    if (i = i.trim(), !!i)
      if (i.indexOf(",") > -1) {
        const o = i.split(",");
        for (let l of o)
          u[l.replace(".", "")] = s;
      } else
        u[i] = s;
  }
  return u;
}, Lr = ts(), za = () => ({
  color: {
    type: [String, Object],
    required: !1,
    default: null
  },
  colorPrimary: {
    type: [String, Object],
    required: !1,
    default: null
  },
  colorSecondary: {
    type: [String, Object],
    required: !1,
    default: null
  },
  colorContainer: {
    type: [String, Object],
    required: !1,
    default: null
  },
  theme: {
    type: String,
    required: !1,
    default: "light"
  },
  colorContextSafe: {
    type: Boolean,
    required: !1,
    default: !0
  }
}), Va = (e) => {
  const t = Xn(), { color: r, logo: u } = jn(t), n = Un(), i = Y(() => {
    var h;
    return n.value ? n.value : (h = B.value) != null && h.isDark() ? "dark" : e.theme ?? "light";
  }), s = Y(() => e.colorContextSafe ?? !0), o = (h) => {
    let w = null;
    return h instanceof E ? w = h : h in Lr ? w = E.fromString(Lr[h]) : w = E.fromString(h), w || es.always.warnFrom("parse", "Invalid color", h), w || E.BLACK;
  }, l = (h) => {
    let w = 0.2, j = 0.1;
    return h.hsl.s <= 0.01 && (w = 0), E.fromHSL({
      h: h.hsl.h,
      s: w,
      l: j
    });
  }, c = (h) => {
    if (h)
      if (h.perceivedBrightness <= E.PERCEIVED_BRIGHTNESS_THRESHOLD) {
        let w = E.WHITE;
        return w.contrastTo(h) < 1.7 ? l(h) : w;
      } else
        return l(h);
    return E.BLACK;
  }, f = (h) => p(i.value, h, _.value), p = (h, w, j, ue) => {
    let re = j, Ce = re.contrastTo(w), ye = 0, we, Ge = re.hsl.h < 0.05;
    switch (h) {
      case "light":
        for (we = ue ?? 3; Ce < we && ye < 24; )
          re = re.darken(2), Ge || (re = re.saturate(2)), Ce = re.contrastTo(w), ye++;
        break;
      case "dark":
        for (we = ue ?? 2.4; Ce < we && ye < 24; )
          re = re.lighten(3).desaturate(2), Ce = re.contrastTo(w), ye++;
        break;
    }
    return re;
  }, m = Y(() => v.value.isWhite()), N = Y(() => v.value.isBlack()), _ = Y(() => {
    var w;
    let h;
    return e.color && e.color != "inherit" ? h = o(e.color) : (w = e.product) != null && w.color ? h = o(e.product.color) : h = F.value, h;
  }), b = Y(() => !!e.color), F = Y(() => e.colorPrimary ? o(e.colorPrimary) : r.value.primary ? r.value.primary : E.BLACK), v = Y(() => e.colorSecondary ? o(e.colorSecondary) : r.value.secondary ? r.value.secondary : E.WHITE), I = Y(() => E.WHITE), B = Y(() => e.colorContainer instanceof E ? e.colorContainer : e.colorContainer && E.fromString(e.colorContainer) || I.value), H = Y(() => F.value.isSimilarTo(v.value, 0.96)), x = Y(() => E.fromString("#3a3a3a")), R = Y(() => {
    const h = _.value, w = h.perceivedBrightness;
    switch (i.value) {
      case "light":
        if (w >= E.PERCEIVED_BRIGHTNESS_THRESHOLD) {
          let j = w - E.PERCEIVED_BRIGHTNESS_THRESHOLD;
          return h.darken(j / 2);
        }
        break;
      case "dark":
        if (w <= E.PERCEIVED_BRIGHTNESS_THRESHOLD) {
          let j = E.PERCEIVED_BRIGHTNESS_THRESHOLD - w;
          return h.lighten(j / 3);
        }
        break;
    }
    return h;
  }), z = Y(() => {
    const h = _.value;
    return s.value && (h.isRedish() || h.isGreenish()) ? x.value : h;
  }), G = Y(() => {
    const h = R.value;
    return s.value && (h.isRedish() || h.isGreenish()) ? x.value : h;
  }), q = Y(() => {
    let h = F.value, w = "light", j = !1, ue = !0;
    return m.value || (v.value.isDark() ? (w = "dark", H.value ? (h = E.WHITE, ue = !1) : h = F.value) : H.value ? v.value.perceivedBrightness >= 160 ? h = R.value : (h = E.WHITE, w = "dark", ue = !1) : h = F.value), {
      theme: w,
      bordered: j,
      color: h,
      shadow: ue
    };
  }), U = Y(() => {
    const h = F.value, w = v.value;
    let j = M.value, ue = "light";
    return w.perceivedBrightness < 176 && (ue = "dark", h.contrastTo(w) >= 4.5 ? j = h : j = E.WHITE), {
      color: j,
      theme: ue
    };
  }), $ = Y(() => E.fromHex("ffffff")), J = Y(() => E.fromHex("222222")), ee = Y(() => {
    if (e.colorContainer)
      if (e.colorContainer.isDark()) {
        let h = e.colorContainer;
        return h.hsl.s < 0.2 ? h = h.withSaturation(0) : h.hsl.l < 0.2 && (h = h.withSaturation(0.2)), h.lighten(52).desaturate(8);
      } else {
        if (e.colorContainer.isWhite())
          return o("light-grey-blue");
        {
          let h = e.colorContainer;
          return h.hsl.s < 0.2 && (h = h.withSaturation(0)), h.darken(48).desaturate(4);
        }
      }
    return o("light-grey-blue");
  }), T = Y(() => c(_.value)), C = Y(() => c(R.value)), g = Y(() => c(G.value)), S = Y(() => c(z.value)), y = Y(() => {
    const h = F.value.perceivedBrightness;
    switch (i.value) {
      case "light":
        if (h <= E.PERCEIVED_BRIGHTNESS_THRESHOLD) {
          let w = F.value, j = w.perceivedBrightness - h;
          if (w.perceivedBrightness > h && j >= 103)
            return w;
        }
        break;
      case "dark":
        if (h >= E.PERCEIVED_BRIGHTNESS_THRESHOLD) {
          let w = F.value, j = h - w.perceivedBrightness;
          if (w.perceivedBrightness < h && j >= 103)
            return w;
        }
        break;
    }
    return c(F.value);
  }), M = Y(() => {
    const h = v.value.perceivedBrightness;
    switch (i.value) {
      case "light":
        if (h <= E.PERCEIVED_BRIGHTNESS_THRESHOLD) {
          let w = v.value, j = w.perceivedBrightness - h;
          if (w.perceivedBrightness > h && j >= 103)
            return w;
        }
        break;
      case "dark":
        if (h >= E.PERCEIVED_BRIGHTNESS_THRESHOLD) {
          let w = v.value, j = h - w.perceivedBrightness;
          if (w.perceivedBrightness < h && j >= 103)
            return w;
        }
        break;
    }
    return c(v.value);
  }), A = Y(() => c(de.value)), L = Y(() => E.WHITE), W = Y(() => _.value), P = Y(() => {
    const h = z.value;
    let w = E.fromHSL({
      h: h.hsl.h,
      s: 0.16,
      l: 0.95
    });
    const j = w.saturate(50);
    return s.value && (j.isRedish() || j.isGreenish()) && (w = w.desaturate(100)), w;
  }), K = Y(() => P.value.darken(2.5)), te = Y(() => {
    const h = z.value;
    let w = E.fromHSL({
      h: h.hsl.h,
      s: 0.47,
      l: 0.2
    });
    const j = w.saturate(50);
    return s.value && (j.isRedish() || j.isGreenish()) && (w = w.desaturate(100)), w;
  }), de = Y(() => e.highlightColor ?? void 0 ? o(e.highlightColor) : o("#f5f8ad")), ie = Y(() => {
    if (e.colorContainer) {
      if (B.value.isWhite())
        return o("#B4BFCE");
      {
        let h = o("#B4BFCE").withHue(B.value.hsl.h);
        return e.colorContainer.hsl.s < 0.2 && (h = h.withSaturation(0)), p(B.value.isDark() ? "dark" : "light", B.value, h, 1.8);
      }
    }
    return o("#B4BFCE");
  }), Ee = Y(() => {
    const h = ie.value;
    return e.colorContainer && B.value.isDark() ? h.shiftHue(-3).desaturate(1).lighten(12) : h.shiftHue(-3).saturate(3).darken(12);
  }), ae = Y(() => E.fromHSL({
    h: 0,
    s: 0,
    l: 100
  }, 0.2));
  return {
    parse: o,
    textContrastFor: c,
    textColoredContrastFor: f,
    ensureIdealContrast: p,
    setTheme: (h) => {
      n.value = h;
    },
    theme: i,
    hasSpecificColor: b,
    PERCEIVED_BRIGHTNESS_THRESHOLD: E.PERCEIVED_BRIGHTNESS_THRESHOLD,
    // Base branding
    branding: {
      logo: u
    },
    // Base colors
    base: _,
    primary: F,
    secondary: v,
    neutralContextSafe: x,
    container: B,
    baseVisuallySafe: R,
    baseContextSafe: z,
    baseVisuallyAndContextSafe: G,
    primaryActionOnSecondary: q,
    secondaryActionOnSecondary: U,
    secondaryIsWhite: m,
    secondaryIsBlack: N,
    brandingColorsAreSimilar: H,
    white: E.WHITE,
    black: E.BLACK,
    // Text
    textLight: $,
    textDark: J,
    textSecondary: ee,
    textContrast: T,
    textVisuallySafeContrast: C,
    textContextSafeContrast: S,
    textVisuallyAndContextSafeContrast: g,
    textHighlight: A,
    textPrimaryContrast: y,
    textSecondaryContrast: M,
    // Focus
    focusLight: L,
    focusDark: W,
    // Backgrounds
    backgroundLightTinted: P,
    backgroundLightTintedDarker: K,
    backgroundDarkTinted: te,
    backgroundHighlight: de,
    // Borders
    inputBorder: ie,
    inputHoverBorder: Ee,
    // Effects
    effectRipple: ae
  };
};
var Bt = { exports: {} }, rs = Bt.exports, Ur;
function iu() {
  return Ur || (Ur = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(rs, function() {
      var r = 1e3, u = 6e4, n = 36e5, i = "millisecond", s = "second", o = "minute", l = "hour", c = "day", f = "week", p = "month", m = "quarter", N = "year", _ = "date", b = "Invalid Date", F = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, v = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, I = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(T) {
        var C = ["th", "st", "nd", "rd"], g = T % 100;
        return "[" + T + (C[(g - 20) % 10] || C[g] || C[0]) + "]";
      } }, B = function(T, C, g) {
        var S = String(T);
        return !S || S.length >= C ? T : "" + Array(C + 1 - S.length).join(g) + T;
      }, H = { s: B, z: function(T) {
        var C = -T.utcOffset(), g = Math.abs(C), S = Math.floor(g / 60), y = g % 60;
        return (C <= 0 ? "+" : "-") + B(S, 2, "0") + ":" + B(y, 2, "0");
      }, m: function T(C, g) {
        if (C.date() < g.date()) return -T(g, C);
        var S = 12 * (g.year() - C.year()) + (g.month() - C.month()), y = C.clone().add(S, p), M = g - y < 0, A = C.clone().add(S + (M ? -1 : 1), p);
        return +(-(S + (g - y) / (M ? y - A : A - y)) || 0);
      }, a: function(T) {
        return T < 0 ? Math.ceil(T) || 0 : Math.floor(T);
      }, p: function(T) {
        return { M: p, y: N, w: f, d: c, D: _, h: l, m: o, s, ms: i, Q: m }[T] || String(T || "").toLowerCase().replace(/s$/, "");
      }, u: function(T) {
        return T === void 0;
      } }, x = "en", R = {};
      R[x] = I;
      var z = "$isDayjsObject", G = function(T) {
        return T instanceof J || !(!T || !T[z]);
      }, q = function T(C, g, S) {
        var y;
        if (!C) return x;
        if (typeof C == "string") {
          var M = C.toLowerCase();
          R[M] && (y = M), g && (R[M] = g, y = M);
          var A = C.split("-");
          if (!y && A.length > 1) return T(A[0]);
        } else {
          var L = C.name;
          R[L] = C, y = L;
        }
        return !S && y && (x = y), y || !S && x;
      }, U = function(T, C) {
        if (G(T)) return T.clone();
        var g = typeof C == "object" ? C : {};
        return g.date = T, g.args = arguments, new J(g);
      }, $ = H;
      $.l = q, $.i = G, $.w = function(T, C) {
        return U(T, { locale: C.$L, utc: C.$u, x: C.$x, $offset: C.$offset });
      };
      var J = function() {
        function T(g) {
          this.$L = q(g.locale, null, !0), this.parse(g), this.$x = this.$x || g.x || {}, this[z] = !0;
        }
        var C = T.prototype;
        return C.parse = function(g) {
          this.$d = function(S) {
            var y = S.date, M = S.utc;
            if (y === null) return /* @__PURE__ */ new Date(NaN);
            if ($.u(y)) return /* @__PURE__ */ new Date();
            if (y instanceof Date) return new Date(y);
            if (typeof y == "string" && !/Z$/i.test(y)) {
              var A = y.match(F);
              if (A) {
                var L = A[2] - 1 || 0, W = (A[7] || "0").substring(0, 3);
                return M ? new Date(Date.UTC(A[1], L, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, W)) : new Date(A[1], L, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, W);
              }
            }
            return new Date(y);
          }(g), this.init();
        }, C.init = function() {
          var g = this.$d;
          this.$y = g.getFullYear(), this.$M = g.getMonth(), this.$D = g.getDate(), this.$W = g.getDay(), this.$H = g.getHours(), this.$m = g.getMinutes(), this.$s = g.getSeconds(), this.$ms = g.getMilliseconds();
        }, C.$utils = function() {
          return $;
        }, C.isValid = function() {
          return this.$d.toString() !== b;
        }, C.isSame = function(g, S) {
          var y = U(g);
          return this.startOf(S) <= y && y <= this.endOf(S);
        }, C.isAfter = function(g, S) {
          return U(g) < this.startOf(S);
        }, C.isBefore = function(g, S) {
          return this.endOf(S) < U(g);
        }, C.$g = function(g, S, y) {
          return $.u(g) ? this[S] : this.set(y, g);
        }, C.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, C.valueOf = function() {
          return this.$d.getTime();
        }, C.startOf = function(g, S) {
          var y = this, M = !!$.u(S) || S, A = $.p(g), L = function(ae, X) {
            var h = $.w(y.$u ? Date.UTC(y.$y, X, ae) : new Date(y.$y, X, ae), y);
            return M ? h : h.endOf(c);
          }, W = function(ae, X) {
            return $.w(y.toDate()[ae].apply(y.toDate("s"), (M ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(X)), y);
          }, P = this.$W, K = this.$M, te = this.$D, de = "set" + (this.$u ? "UTC" : "");
          switch (A) {
            case N:
              return M ? L(1, 0) : L(31, 11);
            case p:
              return M ? L(1, K) : L(0, K + 1);
            case f:
              var ie = this.$locale().weekStart || 0, Ee = (P < ie ? P + 7 : P) - ie;
              return L(M ? te - Ee : te + (6 - Ee), K);
            case c:
            case _:
              return W(de + "Hours", 0);
            case l:
              return W(de + "Minutes", 1);
            case o:
              return W(de + "Seconds", 2);
            case s:
              return W(de + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, C.endOf = function(g) {
          return this.startOf(g, !1);
        }, C.$set = function(g, S) {
          var y, M = $.p(g), A = "set" + (this.$u ? "UTC" : ""), L = (y = {}, y[c] = A + "Date", y[_] = A + "Date", y[p] = A + "Month", y[N] = A + "FullYear", y[l] = A + "Hours", y[o] = A + "Minutes", y[s] = A + "Seconds", y[i] = A + "Milliseconds", y)[M], W = M === c ? this.$D + (S - this.$W) : S;
          if (M === p || M === N) {
            var P = this.clone().set(_, 1);
            P.$d[L](W), P.init(), this.$d = P.set(_, Math.min(this.$D, P.daysInMonth())).$d;
          } else L && this.$d[L](W);
          return this.init(), this;
        }, C.set = function(g, S) {
          return this.clone().$set(g, S);
        }, C.get = function(g) {
          return this[$.p(g)]();
        }, C.add = function(g, S) {
          var y, M = this;
          g = Number(g);
          var A = $.p(S), L = function(K) {
            var te = U(M);
            return $.w(te.date(te.date() + Math.round(K * g)), M);
          };
          if (A === p) return this.set(p, this.$M + g);
          if (A === N) return this.set(N, this.$y + g);
          if (A === c) return L(1);
          if (A === f) return L(7);
          var W = (y = {}, y[o] = u, y[l] = n, y[s] = r, y)[A] || 1, P = this.$d.getTime() + g * W;
          return $.w(P, this);
        }, C.subtract = function(g, S) {
          return this.add(-1 * g, S);
        }, C.format = function(g) {
          var S = this, y = this.$locale();
          if (!this.isValid()) return y.invalidDate || b;
          var M = g || "YYYY-MM-DDTHH:mm:ssZ", A = $.z(this), L = this.$H, W = this.$m, P = this.$M, K = y.weekdays, te = y.months, de = y.meridiem, ie = function(X, h, w, j) {
            return X && (X[h] || X(S, M)) || w[h].slice(0, j);
          }, Ee = function(X) {
            return $.s(L % 12 || 12, X, "0");
          }, ae = de || function(X, h, w) {
            var j = X < 12 ? "AM" : "PM";
            return w ? j.toLowerCase() : j;
          };
          return M.replace(v, function(X, h) {
            return h || function(w) {
              switch (w) {
                case "YY":
                  return String(S.$y).slice(-2);
                case "YYYY":
                  return $.s(S.$y, 4, "0");
                case "M":
                  return P + 1;
                case "MM":
                  return $.s(P + 1, 2, "0");
                case "MMM":
                  return ie(y.monthsShort, P, te, 3);
                case "MMMM":
                  return ie(te, P);
                case "D":
                  return S.$D;
                case "DD":
                  return $.s(S.$D, 2, "0");
                case "d":
                  return String(S.$W);
                case "dd":
                  return ie(y.weekdaysMin, S.$W, K, 2);
                case "ddd":
                  return ie(y.weekdaysShort, S.$W, K, 3);
                case "dddd":
                  return K[S.$W];
                case "H":
                  return String(L);
                case "HH":
                  return $.s(L, 2, "0");
                case "h":
                  return Ee(1);
                case "hh":
                  return Ee(2);
                case "a":
                  return ae(L, W, !0);
                case "A":
                  return ae(L, W, !1);
                case "m":
                  return String(W);
                case "mm":
                  return $.s(W, 2, "0");
                case "s":
                  return String(S.$s);
                case "ss":
                  return $.s(S.$s, 2, "0");
                case "SSS":
                  return $.s(S.$ms, 3, "0");
                case "Z":
                  return A;
              }
              return null;
            }(X) || A.replace(":", "");
          });
        }, C.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, C.diff = function(g, S, y) {
          var M, A = this, L = $.p(S), W = U(g), P = (W.utcOffset() - this.utcOffset()) * u, K = this - W, te = function() {
            return $.m(A, W);
          };
          switch (L) {
            case N:
              M = te() / 12;
              break;
            case p:
              M = te();
              break;
            case m:
              M = te() / 3;
              break;
            case f:
              M = (K - P) / 6048e5;
              break;
            case c:
              M = (K - P) / 864e5;
              break;
            case l:
              M = K / n;
              break;
            case o:
              M = K / u;
              break;
            case s:
              M = K / r;
              break;
            default:
              M = K;
          }
          return y ? M : $.a(M);
        }, C.daysInMonth = function() {
          return this.endOf(p).$D;
        }, C.$locale = function() {
          return R[this.$L];
        }, C.locale = function(g, S) {
          if (!g) return this.$L;
          var y = this.clone(), M = q(g, S, !0);
          return M && (y.$L = M), y;
        }, C.clone = function() {
          return $.w(this.$d, this);
        }, C.toDate = function() {
          return new Date(this.valueOf());
        }, C.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, C.toISOString = function() {
          return this.$d.toISOString();
        }, C.toString = function() {
          return this.$d.toUTCString();
        }, T;
      }(), ee = J.prototype;
      return U.prototype = ee, [["$ms", i], ["$s", s], ["$m", o], ["$H", l], ["$W", c], ["$M", p], ["$y", N], ["$D", _]].forEach(function(T) {
        ee[T[1]] = function(C) {
          return this.$g(C, T[0], T[1]);
        };
      }), U.extend = function(T, C) {
        return T.$i || (T(C, J, U), T.$i = !0), U;
      }, U.locale = q, U.isDayjs = G, U.unix = function(T) {
        return U(1e3 * T);
      }, U.en = R[x], U.Ls = R, U.p = {}, U;
    });
  }(Bt)), Bt.exports;
}
var us = iu();
const Q = /* @__PURE__ */ ve(us);
var St = { exports: {} }, ns = St.exports, jr;
function ss() {
  return jr || (jr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(ns, function() {
      var r = "minute", u = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
      return function(i, s, o) {
        var l = s.prototype;
        o.utc = function(b) {
          var F = { date: b, utc: !0, args: arguments };
          return new s(F);
        }, l.utc = function(b) {
          var F = o(this.toDate(), { locale: this.$L, utc: !0 });
          return b ? F.add(this.utcOffset(), r) : F;
        }, l.local = function() {
          return o(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var c = l.parse;
        l.parse = function(b) {
          b.utc && (this.$u = !0), this.$utils().u(b.$offset) || (this.$offset = b.$offset), c.call(this, b);
        };
        var f = l.init;
        l.init = function() {
          if (this.$u) {
            var b = this.$d;
            this.$y = b.getUTCFullYear(), this.$M = b.getUTCMonth(), this.$D = b.getUTCDate(), this.$W = b.getUTCDay(), this.$H = b.getUTCHours(), this.$m = b.getUTCMinutes(), this.$s = b.getUTCSeconds(), this.$ms = b.getUTCMilliseconds();
          } else f.call(this);
        };
        var p = l.utcOffset;
        l.utcOffset = function(b, F) {
          var v = this.$utils().u;
          if (v(b)) return this.$u ? 0 : v(this.$offset) ? p.call(this) : this.$offset;
          if (typeof b == "string" && (b = function(x) {
            x === void 0 && (x = "");
            var R = x.match(u);
            if (!R) return null;
            var z = ("" + R[0]).match(n) || ["-", 0, 0], G = z[0], q = 60 * +z[1] + +z[2];
            return q === 0 ? 0 : G === "+" ? q : -q;
          }(b), b === null)) return this;
          var I = Math.abs(b) <= 16 ? 60 * b : b, B = this;
          if (F) return B.$offset = I, B.$u = b === 0, B;
          if (b !== 0) {
            var H = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (B = this.local().add(I + H, r)).$offset = I, B.$x.$localOffset = H;
          } else B = this.utc();
          return B;
        };
        var m = l.format;
        l.format = function(b) {
          var F = b || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return m.call(this, F);
        }, l.valueOf = function() {
          var b = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * b;
        }, l.isUTC = function() {
          return !!this.$u;
        }, l.toISOString = function() {
          return this.toDate().toISOString();
        }, l.toString = function() {
          return this.toDate().toUTCString();
        };
        var N = l.toDate;
        l.toDate = function(b) {
          return b === "s" && this.$offset ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : N.call(this);
        };
        var _ = l.diff;
        l.diff = function(b, F, v) {
          if (b && this.$u === b.$u) return _.call(this, b, F, v);
          var I = this.local(), B = o(b).local();
          return _.call(I, B, F, v);
        };
      };
    });
  }(St)), St.exports;
}
var is = ss();
const as = /* @__PURE__ */ ve(is);
var _t = { exports: {} }, os = _t.exports, Pr;
function ls() {
  return Pr || (Pr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(os, function() {
      var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, u = {};
      return function(n, i, s) {
        var o, l = function(m, N, _) {
          _ === void 0 && (_ = {});
          var b = new Date(m), F = function(v, I) {
            I === void 0 && (I = {});
            var B = I.timeZoneName || "short", H = v + "|" + B, x = u[H];
            return x || (x = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: v, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: B }), u[H] = x), x;
          }(N, _);
          return F.formatToParts(b);
        }, c = function(m, N) {
          for (var _ = l(m, N), b = [], F = 0; F < _.length; F += 1) {
            var v = _[F], I = v.type, B = v.value, H = r[I];
            H >= 0 && (b[H] = parseInt(B, 10));
          }
          var x = b[3], R = x === 24 ? 0 : x, z = b[0] + "-" + b[1] + "-" + b[2] + " " + R + ":" + b[4] + ":" + b[5] + ":000", G = +m;
          return (s.utc(z).valueOf() - (G -= G % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(m, N) {
          m === void 0 && (m = o);
          var _, b = this.utcOffset(), F = this.toDate(), v = F.toLocaleString("en-US", { timeZone: m }), I = Math.round((F - new Date(v)) / 1e3 / 60), B = 15 * -Math.round(F.getTimezoneOffset() / 15) - I;
          if (!Number(B)) _ = this.utcOffset(0, N);
          else if (_ = s(v, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(B, !0), N) {
            var H = _.utcOffset();
            _ = _.add(b - H, "minute");
          }
          return _.$x.$timezone = m, _;
        }, f.offsetName = function(m) {
          var N = this.$x.$timezone || s.tz.guess(), _ = l(this.valueOf(), N, { timeZoneName: m }).find(function(b) {
            return b.type.toLowerCase() === "timezonename";
          });
          return _ && _.value;
        };
        var p = f.startOf;
        f.startOf = function(m, N) {
          if (!this.$x || !this.$x.$timezone) return p.call(this, m, N);
          var _ = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return p.call(_, m, N).tz(this.$x.$timezone, !0);
        }, s.tz = function(m, N, _) {
          var b = _ && N, F = _ || N || o, v = c(+s(), F);
          if (typeof m != "string") return s(m).tz(F);
          var I = function(R, z, G) {
            var q = R - 60 * z * 1e3, U = c(q, G);
            if (z === U) return [q, z];
            var $ = c(q -= 60 * (U - z) * 1e3, G);
            return U === $ ? [q, U] : [R - 60 * Math.min(U, $) * 1e3, Math.max(U, $)];
          }(s.utc(m, b).valueOf(), v, F), B = I[0], H = I[1], x = s(B).utcOffset(H);
          return x.$x.$timezone = F, x;
        }, s.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, s.tz.setDefault = function(m) {
          o = m;
        };
      };
    });
  }(_t)), _t.exports;
}
var Ds = ls();
const cs = /* @__PURE__ */ ve(Ds);
var Tt = { exports: {} }, fs = Tt.exports, Yr;
function ds() {
  return Yr || (Yr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(fs, function() {
      return function(r, u, n) {
        u.prototype.isBetween = function(i, s, o, l) {
          var c = n(i), f = n(s), p = (l = l || "()")[0] === "(", m = l[1] === ")";
          return (p ? this.isAfter(c, o) : !this.isBefore(c, o)) && (m ? this.isBefore(f, o) : !this.isAfter(f, o)) || (p ? this.isBefore(c, o) : !this.isAfter(c, o)) && (m ? this.isAfter(f, o) : !this.isBefore(f, o));
        };
      };
    });
  }(Tt)), Tt.exports;
}
var hs = ds();
const ps = /* @__PURE__ */ ve(hs);
var Ot = { exports: {} }, Fs = Ot.exports, zr;
function ms() {
  return zr || (zr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(Fs, function() {
      return function(r, u) {
        var n = u.prototype, i = n.format;
        n.format = function(s) {
          var o = this, l = this.$locale();
          if (!this.isValid()) return i.bind(this)(s);
          var c = this.$utils(), f = (s || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(p) {
            switch (p) {
              case "Q":
                return Math.ceil((o.$M + 1) / 3);
              case "Do":
                return l.ordinal(o.$D);
              case "gggg":
                return o.weekYear();
              case "GGGG":
                return o.isoWeekYear();
              case "wo":
                return l.ordinal(o.week(), "W");
              case "w":
              case "ww":
                return c.s(o.week(), p === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return c.s(o.isoWeek(), p === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return c.s(String(o.$H === 0 ? 24 : o.$H), p === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(o.$d.getTime() / 1e3);
              case "x":
                return o.$d.getTime();
              case "z":
                return "[" + o.offsetName() + "]";
              case "zzz":
                return "[" + o.offsetName("long") + "]";
              default:
                return p;
            }
          });
          return i.bind(this)(f);
        };
      };
    });
  }(Ot)), Ot.exports;
}
var gs = ms();
const Cs = /* @__PURE__ */ ve(gs);
var It = { exports: {} }, Es = It.exports, Vr;
function ys() {
  return Vr || (Vr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(Es, function() {
      return function(r, u, n) {
        r = r || {};
        var i = u.prototype, s = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function o(c, f, p, m) {
          return i.fromToBase(c, f, p, m);
        }
        n.en.relativeTime = s, i.fromToBase = function(c, f, p, m, N) {
          for (var _, b, F, v = p.$locale().relativeTime || s, I = r.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], B = I.length, H = 0; H < B; H += 1) {
            var x = I[H];
            x.d && (_ = m ? n(c).diff(p, x.d, !0) : p.diff(c, x.d, !0));
            var R = (r.rounding || Math.round)(Math.abs(_));
            if (F = _ > 0, R <= x.r || !x.r) {
              R <= 1 && H > 0 && (x = I[H - 1]);
              var z = v[x.l];
              N && (R = N("" + R)), b = typeof z == "string" ? z.replace("%d", R) : z(R, f, x.l, F);
              break;
            }
          }
          if (f) return b;
          var G = F ? v.future : v.past;
          return typeof G == "function" ? G(b) : G.replace("%s", b);
        }, i.to = function(c, f) {
          return o(c, f, this, !0);
        }, i.from = function(c, f) {
          return o(c, f, this);
        };
        var l = function(c) {
          return c.$u ? n.utc() : n();
        };
        i.toNow = function(c) {
          return this.to(l(this), c);
        }, i.fromNow = function(c) {
          return this.from(l(this), c);
        };
      };
    });
  }(It)), It.exports;
}
var bs = ys();
const As = /* @__PURE__ */ ve(bs);
var Mt = { exports: {} }, vs = Mt.exports, Gr;
function ws() {
  return Gr || (Gr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(vs, function() {
      var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, u = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, i = /\d\d/, s = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, l = {}, c = function(F) {
        return (F = +F) + (F > 68 ? 1900 : 2e3);
      }, f = function(F) {
        return function(v) {
          this[F] = +v;
        };
      }, p = [/[+-]\d\d:?(\d\d)?|Z/, function(F) {
        (this.zone || (this.zone = {})).offset = function(v) {
          if (!v || v === "Z") return 0;
          var I = v.match(/([+-]|\d\d)/g), B = 60 * I[1] + (+I[2] || 0);
          return B === 0 ? 0 : I[0] === "+" ? -B : B;
        }(F);
      }], m = function(F) {
        var v = l[F];
        return v && (v.indexOf ? v : v.s.concat(v.f));
      }, N = function(F, v) {
        var I, B = l.meridiem;
        if (B) {
          for (var H = 1; H <= 24; H += 1) if (F.indexOf(B(H, 0, v)) > -1) {
            I = H > 12;
            break;
          }
        } else I = F === (v ? "pm" : "PM");
        return I;
      }, _ = { A: [o, function(F) {
        this.afternoon = N(F, !1);
      }], a: [o, function(F) {
        this.afternoon = N(F, !0);
      }], Q: [n, function(F) {
        this.month = 3 * (F - 1) + 1;
      }], S: [n, function(F) {
        this.milliseconds = 100 * +F;
      }], SS: [i, function(F) {
        this.milliseconds = 10 * +F;
      }], SSS: [/\d{3}/, function(F) {
        this.milliseconds = +F;
      }], s: [s, f("seconds")], ss: [s, f("seconds")], m: [s, f("minutes")], mm: [s, f("minutes")], H: [s, f("hours")], h: [s, f("hours")], HH: [s, f("hours")], hh: [s, f("hours")], D: [s, f("day")], DD: [i, f("day")], Do: [o, function(F) {
        var v = l.ordinal, I = F.match(/\d+/);
        if (this.day = I[0], v) for (var B = 1; B <= 31; B += 1) v(B).replace(/\[|\]/g, "") === F && (this.day = B);
      }], w: [s, f("week")], ww: [i, f("week")], M: [s, f("month")], MM: [i, f("month")], MMM: [o, function(F) {
        var v = m("months"), I = (m("monthsShort") || v.map(function(B) {
          return B.slice(0, 3);
        })).indexOf(F) + 1;
        if (I < 1) throw new Error();
        this.month = I % 12 || I;
      }], MMMM: [o, function(F) {
        var v = m("months").indexOf(F) + 1;
        if (v < 1) throw new Error();
        this.month = v % 12 || v;
      }], Y: [/[+-]?\d+/, f("year")], YY: [i, function(F) {
        this.year = c(F);
      }], YYYY: [/\d{4}/, f("year")], Z: p, ZZ: p };
      function b(F) {
        var v, I;
        v = F, I = l && l.formats;
        for (var B = (F = v.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(U, $, J) {
          var ee = J && J.toUpperCase();
          return $ || I[J] || r[J] || I[ee].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(T, C, g) {
            return C || g.slice(1);
          });
        })).match(u), H = B.length, x = 0; x < H; x += 1) {
          var R = B[x], z = _[R], G = z && z[0], q = z && z[1];
          B[x] = q ? { regex: G, parser: q } : R.replace(/^\[|\]$/g, "");
        }
        return function(U) {
          for (var $ = {}, J = 0, ee = 0; J < H; J += 1) {
            var T = B[J];
            if (typeof T == "string") ee += T.length;
            else {
              var C = T.regex, g = T.parser, S = U.slice(ee), y = C.exec(S)[0];
              g.call($, y), U = U.replace(y, "");
            }
          }
          return function(M) {
            var A = M.afternoon;
            if (A !== void 0) {
              var L = M.hours;
              A ? L < 12 && (M.hours += 12) : L === 12 && (M.hours = 0), delete M.afternoon;
            }
          }($), $;
        };
      }
      return function(F, v, I) {
        I.p.customParseFormat = !0, F && F.parseTwoDigitYear && (c = F.parseTwoDigitYear);
        var B = v.prototype, H = B.parse;
        B.parse = function(x) {
          var R = x.date, z = x.utc, G = x.args;
          this.$u = z;
          var q = G[1];
          if (typeof q == "string") {
            var U = G[2] === !0, $ = G[3] === !0, J = U || $, ee = G[2];
            $ && (ee = G[2]), l = this.$locale(), !U && ee && (l = I.Ls[ee]), this.$d = function(S, y, M, A) {
              try {
                if (["x", "X"].indexOf(y) > -1) return new Date((y === "X" ? 1e3 : 1) * S);
                var L = b(y)(S), W = L.year, P = L.month, K = L.day, te = L.hours, de = L.minutes, ie = L.seconds, Ee = L.milliseconds, ae = L.zone, X = L.week, h = /* @__PURE__ */ new Date(), w = K || (W || P ? 1 : h.getDate()), j = W || h.getFullYear(), ue = 0;
                W && !P || (ue = P > 0 ? P - 1 : h.getMonth());
                var re, Ce = te || 0, ye = de || 0, we = ie || 0, Ge = Ee || 0;
                return ae ? new Date(Date.UTC(j, ue, w, Ce, ye, we, Ge + 60 * ae.offset * 1e3)) : M ? new Date(Date.UTC(j, ue, w, Ce, ye, we, Ge)) : (re = new Date(j, ue, w, Ce, ye, we, Ge), X && (re = A(re).week(X).toDate()), re);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            }(R, q, z, I), this.init(), ee && ee !== !0 && (this.$L = this.locale(ee).$L), J && R != this.format(q) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
          } else if (q instanceof Array) for (var T = q.length, C = 1; C <= T; C += 1) {
            G[1] = q[C - 1];
            var g = I.apply(this, G);
            if (g.isValid()) {
              this.$d = g.$d, this.$L = g.$L, this.init();
              break;
            }
            C === T && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else H.call(this, x);
        };
      };
    });
  }(Mt)), Mt.exports;
}
var Bs = ws();
const Ss = /* @__PURE__ */ ve(Bs);
var xt = { exports: {} }, _s = xt.exports, Wr;
function Ts() {
  return Wr || (Wr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(_s, function() {
      return function(r, u, n) {
        var i = u.prototype, s = function(p) {
          return p && (p.indexOf ? p : p.s);
        }, o = function(p, m, N, _, b) {
          var F = p.name ? p : p.$locale(), v = s(F[m]), I = s(F[N]), B = v || I.map(function(x) {
            return x.slice(0, _);
          });
          if (!b) return B;
          var H = F.weekStart;
          return B.map(function(x, R) {
            return B[(R + (H || 0)) % 7];
          });
        }, l = function() {
          return n.Ls[n.locale()];
        }, c = function(p, m) {
          return p.formats[m] || function(N) {
            return N.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(_, b, F) {
              return b || F.slice(1);
            });
          }(p.formats[m.toUpperCase()]);
        }, f = function() {
          var p = this;
          return { months: function(m) {
            return m ? m.format("MMMM") : o(p, "months");
          }, monthsShort: function(m) {
            return m ? m.format("MMM") : o(p, "monthsShort", "months", 3);
          }, firstDayOfWeek: function() {
            return p.$locale().weekStart || 0;
          }, weekdays: function(m) {
            return m ? m.format("dddd") : o(p, "weekdays");
          }, weekdaysMin: function(m) {
            return m ? m.format("dd") : o(p, "weekdaysMin", "weekdays", 2);
          }, weekdaysShort: function(m) {
            return m ? m.format("ddd") : o(p, "weekdaysShort", "weekdays", 3);
          }, longDateFormat: function(m) {
            return c(p.$locale(), m);
          }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
        };
        i.localeData = function() {
          return f.bind(this)();
        }, n.localeData = function() {
          var p = l();
          return { firstDayOfWeek: function() {
            return p.weekStart || 0;
          }, weekdays: function() {
            return n.weekdays();
          }, weekdaysShort: function() {
            return n.weekdaysShort();
          }, weekdaysMin: function() {
            return n.weekdaysMin();
          }, months: function() {
            return n.months();
          }, monthsShort: function() {
            return n.monthsShort();
          }, longDateFormat: function(m) {
            return c(p, m);
          }, meridiem: p.meridiem, ordinal: p.ordinal };
        }, n.months = function() {
          return o(l(), "months");
        }, n.monthsShort = function() {
          return o(l(), "monthsShort", "months", 3);
        }, n.weekdays = function(p) {
          return o(l(), "weekdays", null, null, p);
        }, n.weekdaysShort = function(p) {
          return o(l(), "weekdaysShort", "weekdays", 3, p);
        }, n.weekdaysMin = function(p) {
          return o(l(), "weekdaysMin", "weekdays", 2, p);
        };
      };
    });
  }(xt)), xt.exports;
}
var Os = Ts();
const Is = /* @__PURE__ */ ve(Os);
var Nt = { exports: {} }, Ms = Nt.exports, qr;
function xs() {
  return qr || (qr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(Ms, function() {
      return function(r, u) {
        u.prototype.weekday = function(n) {
          var i = this.$locale().weekStart || 0, s = this.$W, o = (s < i ? s + 7 : s) - i;
          return this.$utils().u(n) ? o : this.subtract(o, "day").add(n, "day");
        };
      };
    });
  }(Nt)), Nt.exports;
}
var Ns = xs();
const Rs = /* @__PURE__ */ ve(Ns);
var Rt = { exports: {} }, ks = Rt.exports, Qr;
function $s() {
  return Qr || (Qr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u();
    })(ks, function() {
      var r = "month", u = "quarter";
      return function(n, i) {
        var s = i.prototype;
        s.quarter = function(c) {
          return this.$utils().u(c) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (c - 1));
        };
        var o = s.add;
        s.add = function(c, f) {
          return c = Number(c), this.$utils().p(f) === u ? this.add(3 * c, r) : o.bind(this)(c, f);
        };
        var l = s.startOf;
        s.startOf = function(c, f) {
          var p = this.$utils(), m = !!p.u(f) || f;
          if (p.p(c) === u) {
            var N = this.quarter() - 1;
            return m ? this.month(3 * N).startOf(r).startOf("day") : this.month(3 * N + 2).endOf(r).endOf("day");
          }
          return l.bind(this)(c, f);
        };
      };
    });
  }(Rt)), Rt.exports;
}
var Hs = $s();
const Ls = /* @__PURE__ */ ve(Hs);
var kt = { exports: {} }, Us = kt.exports, Zr;
function js() {
  return Zr || (Zr = 1, function(e, t) {
    (function(r, u) {
      e.exports = u(iu());
    })(Us, function(r) {
      function u(s) {
        return s && typeof s == "object" && "default" in s ? s : { default: s };
      }
      var n = u(r), i = { name: "nb", weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"), weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"), weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"), months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"), monthsShort: "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"), ordinal: function(s) {
        return s + ".";
      }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY [kl.] HH:mm", LLLL: "dddd D. MMMM YYYY [kl.] HH:mm" }, relativeTime: { future: "om %s", past: "%s siden", s: "noen sekunder", m: "ett minutt", mm: "%d minutter", h: "en time", hh: "%d timer", d: "en dag", dd: "%d dager", M: "en måned", MM: "%d måneder", y: "ett år", yy: "%d år" } };
      return n.default.locale(i, null, !0), i;
    });
  }(kt)), kt.exports;
}
js();
Q.locale("nb");
Q.extend(as);
Q.extend(cs);
Q.extend(ps);
Q.extend(Cs);
Q.extend(As);
Q.extend(Ss);
Q.extend(Is);
Q.extend(Rs);
Q.extend(Ls);
const k = class k {
  constructor(...t) {
    De(this, "dayjs");
    if (t[0] instanceof Q ? this.dayjs = t[0] : this.dayjs = Q.tz(...t, "Europe/Berlin"), !this.dayjs.isValid())
      throw new Error("Date is invalid: " + t);
  }
  /**
   * Clone this object.
   *
   * @return {DateTimeExt}
   */
  clone() {
    return new k(this.dayjs.clone());
  }
  /**
   * Get a clone of this object in UTC time.
   *
   * @return {DateTimeExt}
   */
  get utc() {
    return new k(this.dayjs.clone().utc());
  }
  /**
   * Get a clone of this object in local time
   *
   * @return {DateTimeExt}
   */
  get local() {
    return new k(this.dayjs.clone().local());
  }
  /**
   * Get the seconds-based UNIX timestamp
   */
  get unixTimestamp() {
    return this.getTimestamp(!0);
  }
  /**
   * Get the milliseconds-based JS Date() timestamp
   */
  get jsTimestamp() {
    return this.getTimestamp(!1);
  }
  /**
   * number of seconds
   *
   * @return {number}
   */
  get seconds() {
    return this.dayjs.second();
  }
  set seconds(t) {
    this.dayjs = this.dayjs.second(t);
  }
  /**
   * number of minutes
   *
   * @return {number}
   */
  get minutes() {
    return this.dayjs.get("minute");
  }
  set minutes(t) {
    this.dayjs = this.dayjs.set("minute", t);
  }
  /**
   * number of hours
   *
   * @return {number}
   */
  get hours() {
    return this.dayjs.hour();
  }
  set hours(t) {
    this.dayjs = this.dayjs.hour(t);
  }
  /**
   * Day of the month
   *
   * @return {number}
   */
  get date() {
    return this.dayjs.date();
  }
  /**
   * Day of the month
   *
   * @return {number}
   */
  get day() {
    return this.date;
  }
  set date(t) {
    this.dayjs = this.dayjs.date(t);
  }
  set day(t) {
    this.date = t;
  }
  /**
   * Day of the week
   *
   * @return {number}
   */
  get weekday() {
    return this.dayjs.weekday();
  }
  set weekday(t) {
    this.dayjs = this.dayjs.weekday(t);
  }
  /**
   * month, 0-11
   *
   * @return {number}
   */
  get month() {
    return this.dayjs.month();
  }
  set month(t) {
    this.dayjs = this.dayjs.month(t);
  }
  /**
   * Quarter of the year
   *
   * @return {number}
   */
  get quarter() {
    return this.dayjs.quarter();
  }
  set quarter(t) {
    this.dayjs = this.dayjs.quarter(t);
  }
  /**
   * Year
   *
   * @return {number}
   */
  get year() {
    return this.dayjs.year();
  }
  set year(t) {
    this.dayjs = this.dayjs.year(t);
  }
  set(t, r) {
    return this.dayjs[t](r), this;
  }
  get(t) {
    return this.dayjs[t]();
  }
  setTime(t, r, u) {
    return this.hours = t, this.minutes = r, this.seconds = u, this;
  }
  /**
   * Implementation of add(...args)
   *
   * @param  {any[]} args Arguments for dayjs()
   *
   * @return {DateTimeExt}
   */
  add(...t) {
    return new k(this.dayjs.add(...t));
  }
  /**
   * Implementation of subtract(...args)
   *
   * @param  {any[]} args Arguments for dayjs()
   *
   * @return {DateTimeExt}
   */
  subtract(...t) {
    return new k(this.dayjs.subtract(...t));
  }
  /**
   * Set the date to the start of a unit
   *
   * @param {string} unit What to set the start to {DateTimeExt.UNIT_*}
   *
   * @return {DateTimeExt}
   */
  startOf(t) {
    return new k(this.dayjs.startOf(t));
  }
  /**
   * Set the date to the end of a unit
   *
   * @param {string} unit What to set the end to {DateTimeExt.UNIT_*}
   *
   * @return {DateTimeExt}
   */
  endOf(t) {
    return new k(this.dayjs.endOf(t));
  }
  /**
   * Similar to Date.toString(), i.e. "Sat Apr 30 2016 16:59:46 GMT-0500"
   *
   * @return {string}
   */
  toString() {
    return this.dayjs.format();
  }
  toMySQLString() {
    return this.format("YYYY-MM-DD HH:mm:ss");
  }
  /**
   * Formats a string to the ISO8601 standard, i.e. "2013-02-04T22:44:30.652Z"
   *
   * @return {string}
   */
  toISOString() {
    return this.dayjs.toISOString();
  }
  /**
   * Converts this DateTimeExt to native Date
   *
   * @return {Date}
   */
  toDate() {
    return this.dayjs.toDate();
  }
  /**
   * This returns an array that mirrors the parameters from new Date(), i.e. [2013, 1, 4, 14, 40, 16, 154]
   *
   * @return {number[]}
   */
  toArray() {
    return this.dayjs.toArray();
  }
  /**
   * This returns an object containing year, month, day-of-month, hour, minute, seconds, milliseconds, i.e.:
   * {
   *     years: 2015
   *     months: 6
   *     date: 26,
   *     hours: 1,
   *     minutes: 53,
   *     seconds: 14,
   *     milliseconds: 600
   * }
   *
   * @return {Object}
   */
  toObject() {
    return this.dayjs.toObject();
  }
  /**
   * When serializing an object to JSON. It will be represented as aa UNIX timestamp (seconds)
   *
   * @return {number}
   */
  toJSON() {
    return this.getTimestamp();
  }
  /**
   * simply outputs the number of milliseconds or seconds since the Unix Epoch,
   *
   * @param  {boolean = false}  unix  If true, seconds are used. If false, milliseconds are used.
   *
   * @return {number}
   */
  valueOf(t = !1) {
    return t ? this.dayjs.unix() : this.dayjs.valueOf();
  }
  /**
   * Proxy for dayjs()
   *
   * @return {string}
   */
  format(...t) {
    return this.dayjs.format(...t);
  }
  /**
   * Check if the date is before a certain other date
   *
   * @param {DateTimeExt|string|number|Date|Dayjs|any[]}  arg         Other Date
   * @param precision                                                                    'year', 'month', 'day', 'hour', …
   */
  isBefore(t, r) {
    return this.dayjs.isBefore(t, r);
  }
  /**
   * Check if the date is after a certain other date
   *
   * @param {DateTimeExt|string|number|Date|Dayjs|any[]}  arg         Other Date
   * @param precision                                                                    'year', 'month', 'day', 'hour', …
   */
  isAfter(t, r) {
    return this.dayjs.isAfter(t, r);
  }
  /**
   * Check if the date is after a certain other date
   *
   * @param {DateTimeExt|string|number|Date|Dayjs|any[]}  arg1         Date 1
   * @param {DateTimeExt|string|number|Date|Dayjs|any[]}  arg2         Date 2
   * @param precision                                                                    'year', 'month', 'day', 'hour', …
   */
  isBetween(t, r, u) {
    return t instanceof k && (t = t.dayjs), r instanceof k && (r = r.dayjs), this.dayjs.isBetween(t, r, u, "[]");
  }
  calendar(t, r) {
    return t instanceof k && (t = t.dayjs), this.dayjs.calendar(t, r);
  }
  /**
   * A common way of displaying time. This is sometimes called time ago or relative time.
   *
   * @param  {boolean = true}  withSuffix  Whether or not to append "ago"
   *
   * @return {string}
   */
  fromNow(t = !0) {
    return this.dayjs.fromNow(!t);
  }
  /**
   * A common way of displaying time. This is sometimes called time ago or relative time.
   * In contrast to fromNow() this allows any other time to be chosen.
   *
   * @param  {DateTimeExt|string|number|Date|Dayjs|any[]}  arg         Other Date to be relative to
   * @param  {boolean = true}                               withSuffix  Whether or not to append "ago"
   *
   * @return {string}
   */
  from(t, r = !0) {
    return t instanceof k && (t = t.dayjs), this.dayjs.from(t, !r);
  }
  /**
   * A common way of displaying time. This is sometimes called time ago or relative time.
   *
   * @param  {boolean = true}  withSuffix  Whether or not to append "ago"
   *
   * @return {string}
   */
  toNow(t = !0) {
    return this.dayjs.toNow(!t);
  }
  /**
   * A common way of displaying time. This is sometimes called time ago or relative time.
   * In contrast to toNow() this allows any other time to be chosen.
   *
   * @param  {DateTimeExt|string|number|Date|Dayjs|any[]}  arg         Other Date to be relative to
   * @param  {boolean = true}                               withSuffix  Whether or not to append "ago"
   *
   * @return {string}
   */
  to(t, r = !0) {
    return t instanceof k && (t = t.dayjs), this.dayjs.to(t, !r);
  }
  /**
   * Calculate the difference between this and another date.
   * When writing such an expression, think of it as a subtraction operation, i.e.:
   *     this.diff(other)  ->  this - other
   *
   * @param  {DateTimeExt|number|string|Date|any[]}  arg    Anything the DateTimeExt constructor accepts as well
   * @param  {string = undefined}                    unit   Unit. Use DateTimeExt::UNIT_* or leave it off entirely.
   * @param  {boolean = undefined}                   float  If true, result can be a floating point number
   *
   * @return {number|string}
   */
  diff(t, r = void 0, u = void 0) {
    if (t instanceof k && (t = t.dayjs), r != null && !k.UNITS.filter((n) => n == r).length)
      throw new Error("Invalid unit.");
    return this.dayjs.diff(t, r, u);
  }
  changeLocale(t) {
    return this.dayjs.locale(t), this;
  }
  static changeGlobalLocale(t) {
    return Q.locale(t), k;
  }
  getTimestamp(t = !0) {
    return t ? this.dayjs.unix() : this.dayjs.valueOf();
  }
  setTimestamp(t, r = !0) {
    return r ? this.dayjs = Q.unix(t) : this.dayjs = Q(t), this;
  }
  /**
   * Create a new instance from a timestamp in milliseconds or seconds (default).
   *
   * @param  {number}          timestamp  Timestamp
   * @param  {boolean = true}  unix       If true, seconds are assumed
   *
   * @return {DateTimeExt}
   */
  static fromTimestamp(t, r = !0) {
    return r ? new k(Q.unix(t)) : new k(Q(t));
  }
  static formatTimestamp(t, r) {
    return k.fromTimestamp(t).format(r);
  }
  static getCurrentTimestamp(t = !0) {
    return t ? Math.round(+/* @__PURE__ */ new Date() / 1e3) : +/* @__PURE__ */ new Date();
  }
  /**
   * Create a new instance from a string in format DD.MM.YYYY with optional leading zeros
   *
   * @param  {string} str String
   *
   * @return {DateTimeExt|null}
   */
  static fromString(t) {
    let r = t.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
    if (r) {
      let u = parseInt(r[1]), n = parseInt(r[2]) - 1, i = parseInt(r[3]), s = k.now();
      return s.date = u, s.month = n, s.year = i, s.hours = 2, s.minutes = 0, s.seconds = 0, s;
    }
    return null;
  }
  static fromFormats(t, r) {
    const u = Q(t, r, void 0, !0);
    return new k(u);
  }
  /**
   * Create DateTimeExt from UTC time.
   * Accepts anything the DateTimeExt constructor accepts as well.
   *
   * @param  {any[]}  args  Arguments
   *
   * @return {DateTimeExt}
   */
  static fromUTC(...t) {
    return new k(Q.utc(...t));
  }
  /**
   * Get a now-instance.
   *
   * @return {DateTimeExt}
   */
  static now() {
    return new k(Q.tz(void 0, "Europe/Berlin"));
  }
  /**
   * Return maximum date from the ones given.
   *
   * @param  {DateTimeExt[]} dates Dates
   *
   * @return {DateTimeExt}
   */
  /*public static max(...dates: any[]): DateTimeExt {
   return new DateTimeExt(dayjs.max(dates))
   }*/
  /**
   * Return minimum date from the ones given.
   *
   * @param  {DateTimeExt[]} dates Dates
   *
   * @return {DateTimeExt}
   */
  /*public static min(...dates: any[]): DateTimeExt {
   return new DateTimeExt(dayjs.min(dates))
   }*/
  /**
   * Create a date range
   *
   * @param {DateTimeExt} start
   * @param {"month" | "year" | "quarter"} range
   *
   * @return {{start: DateTimeExt, end: DateTimeExt}}
   */
  static createRange(t, r) {
    if (r !== "month" && r !== "year" && r !== "quarter")
      throw new Error('Invalid argument "' + r + "' for range in DateTimeExt.createRange()");
    t = t.clone().setTime(0, 0, 0).startOf(r);
    let u = t.clone().add(1, r).subtract(1, "second");
    return {
      start: t,
      end: u
    };
  }
  /**
   * Translate a number of minutes into a more human-readable version, if possible
   *
   * e.g.:
   *  120 -> 2 hours
   *  121 -> 121 minutes
   *  1440 -> 1 day
   *  1500 -> 25 hours
   *  1505 -> 1505 minutes
   *  etc.
   *
   * @param {number} minutes
   * @returns {[number, string]} Value, DateTimeExt.UNIT_* (minute, hour, day only)
   */
  static minutesToHuman(t) {
    let r = Math.abs(t);
    return r % 1440 == 0 ? [
      r / 1440,
      k.UNIT_DAY
    ] : r % 60 == 0 ? [
      r / 60,
      k.UNIT_HOUR
    ] : [
      r,
      k.UNIT_MINUTE
    ];
  }
  /**
   * Translate a value in a unit into a number of minutes
   *
   * @param {number} value    Value
   * @param {string} unit     Use DateTimeExt.UNIT_* (minute, hour, day only)
   * @returns {number}
   */
  static humanToMinutes(t, r) {
    let u = {
      [k.UNIT_DAY]: 1440,
      [k.UNIT_HOUR]: 60,
      [k.UNIT_MINUTE]: 1
    }[r] ?? 1;
    return t * u;
  }
  /**
   * Get all month names
   *
   * @return {string[]}
   */
  static months() {
    return Q.months();
  }
  /**
   * Get a specific month's name, zero-indexed
   *
   * @param {number} which
   *
   * @return {string}
   */
  static monthFor(t) {
    return Q.months()[t];
  }
  /**
   * Get all month short names (e.g. Apr for April)
   *
   * @return {string[]}
   */
  static monthsShort() {
    return Q.monthsShort();
  }
  /**
   * Get a specific month's short name
   *
   * @param {number} which
   *
   * @return {string}
   */
  static monthShortFor(t) {
    return Q.monthsShort()[t];
  }
  /**
   * Get all weekday names
   *
   * @param {boolean} localeSorted If true, sorted according to locale (e.g. Montag/Mandag = 0 for German, Norwegian etc.), else Sunday = 0
   *
   * @return {string[]}
   */
  static weekdays(t = !1) {
    return Q.weekdays(t);
  }
  /**
   * Get a specific weekday's name
   *
   * @param {number} which
   *
   * @return {string}
   */
  static weekdayFor(t) {
    return Q.weekdays()[t];
  }
  /**
   * Get all weekday short names
   *
   * @param {boolean} localeSorted If true, sorted according to locale (e.g. Mon/Man = 0 for German, Norwegian etc.), else Sun = 0
   *
   * @return {string[]}
   */
  static weekdaysShort(t = !1) {
    return Q.weekdaysShort(t);
  }
  /**
   * Get a specific weekday's short name
   *
   * @param {number} which
   *
   * @return {string}
   */
  static weekdayShortFor(t) {
    return Q.weekdaysShort()[t];
  }
  /**
   * Returns the first weekday as a number between 0-6. 0 = Sunday, 6 = Saturday
   *
   * @return {number}
   */
  static firstDayOfWeek() {
    return k.now().startOf("week").weekday;
  }
};
De(k, "UNIT_SECOND", "second"), De(k, "UNIT_MINUTE", "minute"), De(k, "UNIT_HOUR", "hour"), De(k, "UNIT_DAY", "day"), De(k, "UNIT_WEEK", "week"), De(k, "UNIT_MONTH", "month"), De(k, "UNIT_QUARTER", "quarter"), De(k, "UNIT_YEAR", "year"), De(k, "UNITS", [
  k.UNIT_SECOND,
  k.UNIT_MINUTE,
  k.UNIT_HOUR,
  k.UNIT_DAY,
  k.UNIT_WEEK,
  k.UNIT_MONTH,
  k.UNIT_QUARTER,
  k.UNIT_YEAR
]);
let ce = k;
const Ps = (e, t, r) => {
  let u = {};
  for (let n of e)
    u[t(n) || ""] = r ? r(n) : n;
  return u;
}, Kr = (e) => Ps(e, (t) => t, (t) => !0), Ga = (e, t) => {
  const r = [], u = t ?? ((n, i) => n);
  return Se(e, (n, i) => {
    r.push(u(n, i));
  }), r;
}, Wa = (e, t) => Object.keys(e).filter((r) => t(e[r], r)).reduce((r, u) => (r[u] = e[u], r), {}), qa = (e, t) => {
  Object.keys(e).forEach((r) => e[r] = t(e[r], r));
}, Qa = (e, t) => {
  let r = {};
  for (let u in e)
    e.hasOwnProperty(u) && (r[u] = t(e[u], u));
  return r;
}, Se = (e, t) => {
  for (let r in e)
    e.hasOwnProperty(r) && t(e[r], r);
}, Ys = async (e, t) => {
  const r = [];
  for (let u in e)
    e.hasOwnProperty(u) && r.push(t(e[u], u));
  await Promise.all(r);
}, rr = (e) => !!e && typeof e == "object" && !Array.isArray(e), ar = (e, ...t) => {
  if (!t.length) return e;
  const r = t.shift();
  if (rr(e) && rr(r))
    for (const u in r)
      rr(r[u]) ? (e[u] || Object.assign(e, { [u]: {} }), ar(e[u], r[u])) : Object.assign(e, { [u]: r[u] });
  return ar(e, ...t);
}, Za = (e, ...t) => ar({}, e, ...t), je = (e, ...t) => (e === null && (e = {}), Object.assign({}, e, ...t)), Ka = (e, t, r = !1) => (Se(t, (u, n) => {
  r && u !== null || (e[n] = u);
}), e), Ja = (e) => Object.keys(e).map(function(t) {
  if (Array.isArray(e[t])) {
    let r = [];
    for (let u = 0; u < e[t].length; u++)
      r.push(encodeURIComponent(t + "[]") + "=" + encodeURIComponent(e[t][u]));
    return r.join("&");
  }
  return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
}).join("&"), Xa = (e) => {
  if (e == "" || e == null)
    return {};
  let t = e.replace("#", "").split("&"), r = {};
  if (t.length < 1)
    return r;
  for (let u = 0, n = t.length; u < n; u++) {
    let i = t[u].split("="), s = i[0], o = i[1];
    if (s != "")
      try {
        r[s] = JSON.parse(o);
      } catch {
        r[s] = o;
      }
  }
  return r;
}, $t = (e) => Object.keys(e).length, Ye = (e, t, r = 0) => {
  if (!(e === null || e == null)) {
    if (t.length) {
      Array.isArray(t) || (t = t.split("."));
      let u = t.shift();
      if (u == "*") {
        if (Array.isArray(e)) {
          if (t.length) {
            let n = [];
            for (let i of e) {
              let s = JSON.parse(JSON.stringify(t)), o = Ye(i, s, r + 1);
              Array.isArray(o) ? n = n.concat(o.filter((l) => l !== void 0)) : n.push(o);
            }
            return n;
          }
          return e;
        } else if (typeof e == "object") {
          let n = Object.values(e);
          if (t.length) {
            let i = JSON.parse(JSON.stringify(t));
            return i.unshift("*"), Ye(n, i, r + 1);
          }
          return n;
        }
        return;
      } else {
        let n = e[u];
        return t.length ? Ye(n, t, r + 1) : n;
      }
    }
    return e;
  }
}, au = (e, t) => {
  const r = {}, u = (n, i) => {
    if (typeof n != typeof i)
      return !1;
    if (n && !i || i && !n)
      return !1;
    if (typeof n == "object") {
      if (au(n, i).length)
        return !1;
    } else if (n != i)
      return !1;
    return !0;
  };
  for (let n in e)
    if (e.hasOwnProperty(n)) {
      const i = e[n], s = t[n];
      u(i, s) || (r[n] = !0);
    }
  for (let n in t)
    if (t.hasOwnProperty(n)) {
      const i = e[n], s = t[n];
      !r[n] && !u(i, s) && (r[n] = !0);
    }
  return Object.keys(r);
}, zs = (e, t) => {
  let r = {};
  for (let u of t)
    r[u] = e[u];
  return r;
}, eo = (e, t) => {
  const r = {};
  if (e.length != t.length)
    throw new Error("keys and values must have the same length");
  let u = 0;
  for (let n of e)
    r[n] = t[u++];
  return r;
}, ou = (e) => {
  const t = {};
  return Se(e, (r, u) => {
    if (r && typeof r != "string" && typeof r != "number")
      throw new Error("values can only be strings or numbers");
    t[r] = u;
  }), t;
}, to = (e) => ou(Object.assign({}, e)), ro = ru("acquisit-ui-dependencies", {
  state: uu({
    frontend: null,
    backend: null
  })
}), ur = Fe("lib/raygun", "#f4db12"), be = class be {
  /**
   * Configure Raygun
   */
  static init(t, r, u) {
    be.instance = new be(), typeof window < "u" && window.rg4js ? (window.rg4js("apiKey", t), u ? (window.rg4js("enableCrashReporting", !1), console.info("[Raygun] disabled")) : (window.rg4js("enableCrashReporting", !0), window.rg4js("setVersion", r), window.rg4js("options", {
      ignore3rdPartyErrors: !0,
      setCookieAsSecure: !0
    }), console.info("[Raygun] enabled")), window.addEventListener("online", be.onOnline), window.addEventListener("offline", be.onOffline)) : ur.always.info("[Raygun] Not loaded");
  }
  static onOnline() {
    be.instance.recordBreadcrumb("Connection Online", {});
  }
  static onOffline() {
    be.instance.recordBreadcrumb("Offline!", {});
  }
  /**
   * Send an error to Raygun
   *
   * @param {Error}       error       Error to send
   * @param {String[]}    tags        Tags to append
   * @param {AnyObject}   customData  Custom Data to append
   */
  send(t, r = [], u = {}) {
    var n;
    return ur.debugFrom("send", t, "with tags", r, "and data", u), (n = window.rg4js) == null || n.call(window, "send", {
      error: t,
      tags: r,
      customData: u
    }), this;
  }
  /**
   * Record a breadcrumb (event) on Raygun to help aid debug issues
   *
   * data = Custom data to append
   * level = level to report at, use Raygun.DEBUG, Raygun.INFO, Raygun.WARNING or Raygun.ERROR
   * location = where the breadcrumb originated, should be a string of format "file:function"
   *
   * @param {string} message  Message
   * @param {{data?: AnyObject, level?: Raygun.Level, location?: string}} options
   */
  recordBreadcrumb(t, r) {
    var u;
    return ur.debugFrom("recordBreadcrumb:" + (r.level ?? be.Level.INFO), t, r), (u = window.rg4js) == null || u.call(window, "recordBreadcrumb", {
      message: t,
      metadata: r.data ?? {},
      level: r.level ?? be.Level.INFO,
      location: r.location ?? null
    }), this;
  }
  /**
   * Set the user's ID to associate an error with
   *
   * @param {string} id
   *
   * @returns {this}
   */
  setUser(t) {
    var r;
    return (r = window.rg4js) == null || r.call(window, "setUser", {
      identifier: t,
      isAnonymous: !1
    }), this;
  }
  /**
   * Remove any user information
   *
   * @returns {this}
   */
  setAnonymous() {
    var t;
    return (t = window.rg4js) == null || t.call(window, "setUser", {
      isAnonymous: !0
    }), this;
  }
  /**
   * Enable or disable queueing errors if the device is offline to send them when the devices comes back online
   *
   * @param {boolean} state
   *
   * @returns {this}
   */
  saveIfOffline(t) {
    var r;
    return (r = window.rg4js) == null || r.call(window, "saveIfOffline", t), this;
  }
};
De(be, "instance");
let it = be;
((e) => {
  ((t) => {
    t.DEBUG = "debug", t.INFO = "info", t.WARNING = "warning", t.ERROR = "error";
  })(e.Level || (e.Level = {}));
})(it || (it = {}));
const lu = () => {
  if (!it.instance)
    throw new Error("Raygun is not configured, yet");
  return it.instance;
}, Vs = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.data) == null ? void 0 : t.uid) && (e == null ? void 0 : e.components);
};
var Gs = /* @__PURE__ */ ((e) => (e.INCLUDE = "include", e.EXCLUDE = "exclude", e))(Gs || {});
const at = (e) => !!(e !== null && typeof e == "object" && e.tag && e.tag_normalized && typeof e.properties == "object" && !e.pdf), uo = (e) => Array.isArray(e) ? !e.some((t) => !at(t)) : !1, no = (e) => typeof e == "object", so = (e) => !at(e) && !Vs(e) && !!(e != null && e.uid && (e != null && e.components)), Lt = (e) => !!(e !== null && typeof e == "object" && e.pdf && e.tag && e.tag_normalized && e.properties), Ws = (e) => !!(Lt(e) && e.tag == "reference" && e.properties.path), Pt = (e) => !!(Lt(e) && e.properties.rows && e.properties.columns);
var mt = /* @__PURE__ */ ((e) => (e.COMPONENT = "co", e.ITEM = "it", e.METADATA = "meta", e.PERSON = "person", e))(mt || {});
const Jr = (e) => e.map((t) => t.type + ":" + t.uid).join("/"), io = (e) => String(e).split("/").map((t) => {
  const r = t.split(":");
  return {
    type: r[0],
    uid: r[1]
  };
}), qs = () => /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC2\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g, Qs = (e, t, r) => {
  let u = {};
  for (let n of e) {
    let i = t(n);
    u[i] || (u[i] = []), u[i].push(n);
  }
  if (typeof r == "function")
    for (let n in u)
      u.hasOwnProperty(n) && (u[n] = u[n].sort(r));
  return u;
}, ao = (e, t, r = -1) => {
  r == -1 && (r = e.length);
  const u = [...e];
  return u.splice(r, 0, ...t), u;
}, oo = (e, t) => {
  e.splice(t, 1);
}, Zs = (e, t, r = !1) => {
  let u = 0;
  for (let n of e) {
    if (t(n))
      return e.splice(u, 1), r ? void 0 : Zs(e, t, !1);
    u++;
  }
}, lo = (e) => e[Math.round(Math.random() * (e.length - 1))], Do = (e, t, r = !0) => {
  if (!Array.isArray(e) || !Array.isArray(t))
    return !1;
  if (e.length != t.length)
    return !1;
  r && (e = e.sort(), t = t.sort());
  for (let u = 0; u < e.length; u++)
    if (e[u] != t[u])
      return !1;
  return !0;
}, Ks = (e, t, r = !0) => {
  if (!Array.isArray(e) || !Array.isArray(t))
    return !1;
  if (e.length != t.length)
    return !1;
  r && (e = e.sort(), t = t.sort());
  for (let u = 0, n = e.length; u < n; u++) {
    if (typeof e[u] != typeof t[u])
      return !1;
    if (Array.isArray(e[u])) {
      if (!Ks(e[u], t[u]))
        return !1;
    } else if (e[u] && t[u] && typeof e[u] == "object") {
      if (au(e[u], t[u]).length)
        return !1;
    } else if (e[u] != t[u])
      return !1;
  }
  return !0;
}, Js = (e, t) => e.filter((r) => t.indexOf(r) !== -1), co = (e, t) => e.filter((r) => !t.includes(r)), fo = (e, t) => e.filter((r) => !t.includes(r)).concat(t.filter((r) => !e.includes(r))), ho = (e, t = (r) => String(r)) => {
  let r = {}, u = {}, n = [];
  for (let i = 0; i < e.length; i++) {
    let s = t(e[i]);
    r[s] !== void 0 && (u[r[s]] || (n.push(e[r[s]]), u[r[s]] = !0), n.push(e[i])), r[s] = i;
  }
  return n;
}, po = (e, t = (r) => String(r)) => {
  let r = {}, u = {}, n = [];
  for (let i = 0; i < e.length; i++) {
    let s = t(e[i]);
    r[s] !== void 0 && (u[r[s]] || (n.push(r[s]), u[String(r[s])] = !0), n.push(i)), r[s] = i;
  }
  return n;
}, Fo = (...e) => {
  let t = [];
  for (const r of e)
    r && (t = t.concat([...r]));
  return new Set(t);
}, Xs = (e) => {
  let t = 1 / 0;
  for (const r of e)
    r < t && (t = r);
  return t == 1 / 0 ? null : t;
}, mo = (e) => {
  let t = null;
  for (const r of e)
    r > (t || 0) && (t = r);
  return t;
}, go = (e) => Array.from(new Set(e)), Co = (e, t) => {
  if (e.length < t.length)
    return !1;
  for (let r = 0; r < t.length; r++) {
    let u = e[r], n = t[r];
    if (u && typeof u == "object") {
      if (!qn(u, n))
        return !1;
    } else if (u != n)
      return !1;
  }
  return !0;
}, ei = (e, t, r = (u, n) => u == n) => e.length < t.length || !e.length || !t.length ? e : r(e[0], t[0]) ? ei(e.slice(1), t.slice(1)) : e, ti = (e, t, r) => {
  const u = e[t];
  e.splice(t, 1), e.splice(r, 0, u);
}, Eo = (e, t, r) => {
  const u = Array.from(e);
  return ti(u, t, r), u;
}, ri = (e, t, r = "OR") => {
  if (!(e != null && e.length))
    return !1;
  if (Array.isArray(t)) {
    const u = Js(e, t);
    return r == "AND" ? u.length == t.length : u.length > 0;
  }
  return e.indexOf(t) > -1;
}, Yt = (e, t = 8) => e + (Math.random() + 1).toString(36).substring(2, t + 2), yo = (e, t = 2, r = ",", u = ".", n = !1) => {
  e = Number(e);
  let i = [], s;
  n ? s = e.toFixed(t || 0).replace("." + "0".repeat(t), "").toString().split(".") : s = e.toFixed(t || 0).toString().split(".");
  for (let o = s[0].length; o > 0; o -= 3)
    i.unshift(s[0].substring(Math.max(0, o - 3), o));
  return s[0] = i.join(u), s.join(r);
}, bo = (e, t = !1, r = 1) => {
  const u = t ? 1e3 : 1024;
  if (Math.abs(e) < u)
    return e + " B";
  const n = t ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let i = -1;
  const s = 10 ** r;
  do
    e /= u, ++i;
  while (Math.round(Math.abs(e) * s) / s >= u && i < n.length - 1);
  return e.toFixed(r) + " " + n[i];
}, Ao = (e, t, r, u) => e.substring(0, t) + u + e.substring(r), Du = (e) => String(e).trim().replace(/( | |\n|\t)/g, ""), vo = (e) => {
  let t = document.createElement("div");
  return t.innerHTML = e, t.textContent || t.innerText || "";
}, wo = (e) => e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Bo = (e) => String(e).replace(qs(), ""), So = (e) => ({
  page: !0,
  "_page-help": !0,
  __itemUID: !0,
  __itemTemplateUID: !0
})[e] ? !1 : !e.match(/( |"|'| |:|\*)/), _o = (e) => !!String(e).toLocaleLowerCase().match(/^[a-z\d!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z\d!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z\d](?:[a-z\d-]*[a-z\d])?\.)+[a-z\d](?:[a-z\d-]*[a-z\d])?$/), To = (e) => !!String(e).toLocaleLowerCase().match(/^[a-zåœøæßäöüéèáà][a-zåœøæßäöüéèáà& .,\-]+$/), Oo = (e) => !!String(e).match(/^[0-9]{9}$/), Io = (e) => (e = String(e).toLocaleLowerCase(), !!e.match(/[a-zæœøåäöüßáàéè][a-zæœøåäöüßáàéè \d\-]+ ?\d* ?[a-z]*([, ]? ?\d+[,. ]?[a-z]+)?/) && !e.match(/[{}$€%]/)), Mo = (e) => !!String(e).toLocaleLowerCase().match(/^[a-zäöüßæœåøéèáà\d][a-zäöüßæœåøéèáà\d \-]+$/), xo = (e) => {
  const t = String(e).trim();
  return t.length < 4 || t.length > 6 ? !1 : !t.match(/\D/);
}, No = (e) => {
  let t = atob(e.split(",")[1]), r = e.split(",")[0].split(":")[1].split(";")[0], u = new ArrayBuffer(t.length), n = new Uint8Array(u);
  for (let i = 0; i < t.length; i++)
    n[i] = t.charCodeAt(i);
  return new Blob([u], { type: r });
}, Ro = async (e) => new Promise((t, r) => {
  const u = new Image();
  u.setAttribute("crossOrigin", "anonymous"), u.onload = () => {
    const n = document.createElement("canvas");
    n.width = u.width, n.height = u.height, n.getContext("2d").drawImage(u, 0, 0), t(n.toDataURL("image/png"));
  }, u.onerror = r, u.src = e;
}), ko = (e, t, r = "left") => {
  let u = [];
  if (r == "left")
    for (let n = 0, i = e.length; n < i; n += t)
      u.push(e.substring(n, n + t));
  else {
    let n = e.length;
    for (let i = n; i > 0; i -= t) {
      let s = i - t, o = i;
      s < 0 && (s = 0), u.push(e.substring(s, o));
    }
    u = u.reverse();
  }
  return u;
}, $o = (e) => e.replace(/-./g, (t) => t[1].toUpperCase()), Ho = (e) => e.charAt(0).toUpperCase() + e.slice(1), Lo = (e) => {
  let t;
  return e == null ? null : (e instanceof Date ? t = new ce(e) : e instanceof ce ? t = e : t = ce.fromTimestamp(e), t.format("YYYY-MM-DD"));
}, Uo = (e) => {
  let t;
  return e == null ? null : (e instanceof Date ? t = new ce(e) : e instanceof ce ? t = e : t = ce.fromTimestamp(e), t.format("DD.MM.YYYY"));
}, jo = (e) => e.replace(/\n/g, "<br />"), Po = (e) => {
  let t = e.replace(/(^\n*)/, "").replace(/\t*$/, "").replace(/\n*$/, "").split(`
`);
  const r = t.map((n) => {
    var i;
    return ((i = n.match(/^([\t]+)/)) == null ? void 0 : i[0].length) || 0;
  }), u = Xs(r) ?? 0;
  if (u > 0) {
    const n = new RegExp("^	{" + u + "}");
    t = t.map((i) => i.replace(n, ""));
  }
  return t.join(`
`);
}, ui = (e, t) => {
  Array.isArray(t) || (t = [t]);
  for (let r = 0; r < t.length; ++r) {
    const u = t[r].length;
    if (e.substring(0, u) === t[r])
      return r;
  }
  return !1;
}, ni = (e, t) => {
  Array.isArray(t) || (t = [t]);
  for (let r = 0; r < t.length; ++r) {
    const u = t[r].length;
    if (e.substring(e.length - u) === t[r])
      return r;
  }
  return !1;
}, Yo = (e, t) => {
  t = t || "";
  const r = 1024, u = window.atob(e), n = u.length, i = Math.ceil(n / r), s = new Array(i);
  for (let o = 0; o < i; ++o) {
    const l = o * r, c = Math.min(l + r, n), f = new Array(c - l);
    for (let p = l, m = 0; p < c; ++m, ++p)
      f[m] = u[p].charCodeAt(0);
    s[o] = new Uint8Array(f);
  }
  return new Blob(s, { type: t });
};
var pe = /* @__PURE__ */ ((e) => (e.BOOLEAN = "bool", e.NUMBER = "number", e.STRING = "string", e.ARRAY = "array", e.FUNCTION = "function", e.NULL = "null", e))(pe || {}), V = /* @__PURE__ */ ((e) => (e.EQUALS = "==", e.CONTAINS = "=%=", e.BEGINS_WITH = "%=", e.ENDS_WITH = "=%", e.GREATER_THAN_OR_EQUAL = ">=", e.GREATER_THAN = ">", e.LESS_THAN_OR_EQUAL = "<=", e.LESS_THAN = "<", e))(V || {}), fe = /* @__PURE__ */ ((e) => (e.NOT_EQUALS = "!=", e.NOT_BEGINS_WITH = "!%=", e.NOT_ENDS_WITH = "!=%", e.NOT_CONTAINS = "!=%=", e))(fe || {}), xe = /* @__PURE__ */ ((e) => (e.AND = "AND", e.OR = "OR", e))(xe || {}), se = /* @__PURE__ */ ((e) => (e.ADD = "+", e.SUBTRACT = "-", e.MULTIPLY = "*", e.DIVIDE = "/", e.POWER = "^", e))(se || {});
const me = (e) => (e == null ? void 0 : e.type) == "condition", ge = (e) => (e == null ? void 0 : e.type) == "condition_group", Re = (e) => (e == null ? void 0 : e.type) == "term", ke = (e) => (e == null ? void 0 : e.type) == "function", lr = (e) => (e == null ? void 0 : e.type) == "array", gt = (e) => typeof e == "object" && e !== void 0 && e !== null && !me(e) && !ge(e) && !Re(e) && !ke(e) && !lr(e), si = (e, t) => {
  let r = Array.isArray(e.value), u = Array.isArray(t.value);
  if (r && u)
    return e.value.filter((i) => !t.value.includes(i)).length == 0;
  if (r || u) {
    let n = r ? e.value : t.value, i = r ? t.value : e.value;
    for (let s of n)
      if (s != i)
        return !1;
    return !0;
  }
  return e.string == t.string || e.value === null && t.string == "false" || t.value === null && e.string == "false";
}, ii = (e, t) => Number(e.value) < Number(t.value), ai = (e, t) => Number(e.value) <= Number(t.value), oi = (e, t) => Number(e.value) > Number(t.value), li = (e, t) => Number(e.value) >= Number(t.value), Di = (e, t) => typeof e.value != "string" || typeof t.value != "string" ? !1 : e.string.substring(0, t.string.length) == t.string, ci = (e, t) => typeof e.value != "string" || typeof t.value != "string" ? !1 : e.string.substring(e.string.length - t.string.length) == t.string, fi = (e, t) => {
  const r = Array.isArray(e.value), u = Array.isArray(t.value);
  if (r && u) {
    for (let n of e.value)
      if (pt[V.CONTAINS]({ value: n, string: String(n) }, t))
        return !0;
    return !1;
  } else if (r) {
    for (let n of e.value)
      if (n == t.value)
        return !0;
    return !1;
  } else if (u) {
    for (let n of t.value)
      if (pt[V.CONTAINS](e, { value: n, string: String(n) }))
        return !0;
    return !1;
  } else
    return e.string.indexOf(t.string) > -1;
}, di = (e) => e.reduce((t, r) => t + Number(r.value), 0), hi = (e) => {
  let t = e.length ? e[0].value : 0;
  e = Ne(e), e.shift();
  for (let r of e)
    t -= Number(r.value);
  return t;
}, pi = (e) => e.reduce((t, r) => t * Number(r.value), 1), Fi = (e) => {
  let t = e.length ? e[0].value : 1;
  e = Ne(e), e.shift();
  for (let r of e)
    t /= Number(r.value);
  return t;
}, mi = (e) => {
  let t = e.length ? e[0].value : 1;
  e = Ne(e), e.shift();
  for (let r of e)
    t **= Number(r.value);
  return t;
}, pt = {
  [V.EQUALS]: si,
  [V.LESS_THAN]: ii,
  [V.LESS_THAN_OR_EQUAL]: ai,
  [V.GREATER_THAN]: oi,
  [V.GREATER_THAN_OR_EQUAL]: li,
  [V.BEGINS_WITH]: Di,
  [V.ENDS_WITH]: ci,
  [V.CONTAINS]: fi,
  [se.ADD]: di,
  [se.SUBTRACT]: hi,
  [se.MULTIPLY]: pi,
  [se.DIVIDE]: Fi,
  [se.POWER]: mi
}, zo = (e, t) => e.properties.disabled || e.disabled ? !0 : me(e.disabled_condition) || ge(e.disabled_condition) ? $e(e.disabled_condition, t) : !1, gi = (e, t) => {
  let r = (u, n) => {
    for (let i of u)
      if (i.properties.uid == n.properties.uid || Xe(n) && r(Ae(i.children), n))
        return !0;
    return !1;
  };
  for (let u of t)
    if (r(u.components, e))
      return u;
  return null;
}, Ci = (e) => e == null ? pe.NULL : Array.isArray(e) ? pe.ARRAY : {
  string: pe.STRING,
  boolean: pe.BOOLEAN,
  number: pe.NUMBER
}[typeof e] ?? pe.STRING, Vo = (e, t, r, u = !1) => ({
  type: "condition",
  left: e,
  right: r,
  operator: t,
  negated: u
}), Go = (e, t = []) => ({
  type: "condition_group",
  operator: e,
  children: t
}), Ei = (e, t) => ({
  type: pe.FUNCTION,
  name: e,
  children: Array.isArray(t) ? t : [t]
}), Pe = (e) => ({
  type: Ci(e),
  content: e
}), Wo = (...e) => ({
  type: pe.ARRAY,
  children: e
}), qo = (e, ...t) => ({
  type: "term",
  operator: e,
  fields: t
}), ft = (e, t, r) => {
  if (me(e))
    e.left && ft(e.left, t, r), e.right && ft(e.right, t, r);
  else if (ge(e))
    for (let u of e.children)
      ft(u, t, r);
  else if (Re(e))
    for (let u of e.fields)
      ft(u, t, r);
  else if (ke(e)) {
    for (let n of e.children)
      ke(n) && ft(n, t, r);
    const u = ze[e.name];
    u ? u.renameUID(e.children, t, r) : Fe("lib/expressions/helpers.ts").warnFrom("renameUIDInExpression", "Invalid function", e);
  }
}, Qo = (e, t) => {
  const r = {
    componentsMap: Kr(Object.keys(t.componentsByUID)),
    pagesMap: Kr(Object.keys(t.pagesByUID)),
    productsByUID: t.productsByUID,
    scope: t.scope
  };
  if (me(e))
    return Dr(e, r);
  if (ge(e))
    return cr(e, r);
  {
    let u;
    try {
      u = JSON.stringify(e);
    } catch (n) {
      u = typeof n;
    }
    throw new Error("Invalid argument passed to extractUIDs(): " + u);
  }
}, Dr = (e, t) => {
  let r = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
  const i = [e.left, e.right];
  for (let s of i) {
    if (!ke(s))
      continue;
    const o = cu(s, t);
    r = /* @__PURE__ */ new Set([...r, ...o.components]), u = /* @__PURE__ */ new Set([...u, ...o.pages]), n = /* @__PURE__ */ new Set([...n, ...o.products]);
  }
  return {
    components: r,
    pages: u,
    products: n
  };
}, cu = (e, t) => {
  let r = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), { pagesMap: i, componentsMap: s, productsByUID: o } = t, l = e.children.map((f) => me(f) ? Dr(f, t) : ge(f) ? cr(f, t) : ke(f) ? cu(f, t) : gt(f) ? f.content : Re(f) ? null : f).filter((f) => !!f), c = ze[e.name].extractUIDs(l, t);
  for (let f of c)
    i[f] ? u.add(f) : s[f] ? r.add(f) : o[f] && n.add(f);
  return {
    components: r,
    pages: u,
    products: n
  };
}, yi = (e, t = 0) => e.length ? [e[t]] : [], cr = (e, t) => {
  let r = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
  for (let i of e.children) {
    let s;
    ge(i) ? s = cr(i, t) : me(i) ? s = Dr(i, t) : s = [], r = /* @__PURE__ */ new Set([...r, ...s.components]), u = /* @__PURE__ */ new Set([...u, ...s.pages]), n = /* @__PURE__ */ new Set([...n, ...s.products]);
  }
  return {
    components: r,
    pages: u,
    products: n
  };
}, bi = (e) => {
  const t = {
    display: null,
    disabled: null,
    nested: {}
  };
  return e.display_condition && (t.display = e.display_condition), e.disabled_condition && (t.disabled = e.disabled_condition), e.tag_normalized, t;
}, Zo = (e) => ({
  page: {
    display: e.display_condition
  },
  components: fu(e.components)
}), fu = (e) => {
  let t = {};
  for (let r of e)
    t[r.properties.uid] = bi(r), r.children && (t = je(t, fu(Ae(r.children))));
  return t;
}, ot = (e, t, r) => {
  for (let u of e)
    gt(u) && u.content == t && (u.content = r);
}, du = (e, t, r) => {
}, hu = (e) => (t, r) => yi(t, e), pu = (e, t) => [], He = (e) => ({
  evaluate: e,
  extractUIDs: pu,
  renameUID: du
}), fr = {
  evaluate: (e, t) => {
    var n;
    let { componentsByUID: r, pagesByUID: u } = t;
    if (e.length) {
      let i = r[e[0]];
      if (i) {
        let s = gi(i, Object.values(u));
        if (s && !ma(i, s, t))
          return null;
        let o = i.properties.modelValue;
        if (typeof o == "object") {
          let l = Fr([i]), c = { values: {}, items: {} };
          switch (i.tag_normalized) {
            case "items-input":
              c = Ft({
                componentsByUID: l,
                personsByID: t.personsByID,
                productsByUID: t.productsByUID
              }, !1), o = ((n = c.items) == null ? void 0 : n[i.properties.uid]) || c.values[i.properties.uid];
              break;
            case "persons-layout":
              c = Ft({
                componentsByUID: l,
                personsByID: t.personsByID,
                productsByUID: t.productsByUID
              }, !1);
              let f = c.values[i.properties.uid];
              f && (o = f);
              break;
          }
        }
        if (e.length == 1)
          return o;
        if (o)
          return e.shift(), Ye(o, e.join("."));
      }
    }
    return null;
  },
  // Value can receive a number of arguments, representing the path to look up values in nested components
  extractUIDs: (e) => e,
  renameUID: ot
}, Ai = {
  evaluate: (e, t) => {
    if (e.length) {
      let r = fr.evaluate(e, t);
      return Array.isArray(r) ? r.length : 0;
    }
  },
  extractUIDs: (e) => e,
  renameUID: ot
}, vi = {
  evaluate: (e, t) => {
    if (e.length) {
      if (Array.isArray(e[0]))
        return e[0].length == 0;
      let r = fr.evaluate(e, t);
      return Array.isArray(r) ? r.length == 0 : r === "" || r === !1 || r === null || r === void 0 || r === 0;
    } else
      return null;
  },
  extractUIDs: (e) => Array.isArray(e[0]) ? [] : e,
  renameUID: ot
}, wi = {
  evaluate: (e, { pagesByUID: t }) => {
    if (e.length) {
      let r = t[e[0]];
      return r ? r.enabled && r.data.validated : !1;
    }
    return !1;
  },
  extractUIDs: hu(0),
  renameUID: ot
}, Bi = {
  evaluate: (e, { productsByUID: t }) => {
    if (e.length)
      if (e.length == 1) {
        for (let r in t)
          if (t.hasOwnProperty(r) && t[r].product_id == e[0] && t[r].selected)
            return !0;
        return !1;
      } else {
        let r = t[e[0] + "-" + e[1]];
        return !!(r && r.selected);
      }
    return !1;
  },
  extractUIDs: (e, { productsByUID: t }) => {
    if (e.length == 1) {
      for (let r in t)
        if (t.hasOwnProperty(r) && t[r].product_id == e[0])
          return [r];
      return [];
    } else
      return [
        e[0] + "-" + e[1]
      ];
  },
  renameUID: ot
}, Si = {
  evaluate: (e, { componentsByUID: t }) => {
    if (!e[0] || typeof e[0] != "string")
      return !1;
    if (t[e[0]]) {
      const r = t[e[0]];
      return r.tag_normalized == "single-product-chooser-carousel" ? r.properties.already_ordered ?? !1 : !1;
    }
    return !1;
  },
  extractUIDs: hu(0),
  renameUID: ot
}, _i = He((e, { personsByID: t }) => {
  const r = Object.values(t), u = Qs(r, (n) => n.type);
  if (e.length) {
    if (e.length == 3 && e[1] == "*" && e[2] == "fullname") {
      const n = Ye(u, [e[0], "*", "firstname"]), i = Ye(u, [e[0], "*", "name"]), s = [];
      for (let o = 0, l = i.length; o < l; o++)
        s.push([n[o], i[o]].filter((c) => !!c).join(" "));
      return s;
    }
    return Ye(u, e);
  }
  return r;
}), Ti = He((e, { scope: t }) => {
  if (e.length && t.person) {
    let r = Ye(t.person, e.join("."));
    return r === void 0 ? null : r;
  }
  return null;
}), Ko = He((e) => e.length == 1 ? e[0] : e), _e = (e, t, r, u = 0) => ({
  evaluate: (n) => n.length ? (r > -1 && (n = n.slice(0, r)), t(...n)) : u,
  extractUIDs: pu,
  renameUID: du
}), Oi = _e("sqrt", Math.sqrt, 1, 1), Ii = _e("sin", Math.sin, 1, 1), Mi = _e("cos", Math.cos, 1, 1), xi = _e("tan", Math.tan, 1, 1), Ni = _e("abs", Math.abs, 1, 1), Ri = _e("min", Math.min, -1, 0), ki = _e("max", Math.max, -1, 0), $i = _e("floor", Math.floor, 1, 0), Hi = _e("ceil", Math.ceil, 1, 0), Li = _e("round", Math.round, 1, 0), Je = (e, t = "argument must be a date, e.g. created by DATE_CREATE") => {
  if (!(e instanceof ce))
    throw new Error(t);
  return e;
}, Ve = (e) => He((t) => Je(t[0])[e]), Ui = He(() => ce.now()), ji = He((e) => {
  const t = e[0] ?? void 0;
  if (typeof t == "boolean")
    throw new Error("Cannot create date from " + JSON.stringify(t));
  if (t) {
    if (typeof t == "number")
      return ce.fromTimestamp(t);
    if (typeof t == "string")
      return ce.fromFormats(t, [
        "DD.MM.YYYY, HH:mm",
        "DD.MM.YYYY",
        "YYYY-MM-DD HH:mm",
        "YYYY-MM-DD"
      ]);
    if (t instanceof ce)
      return t;
    throw typeof t != "function" ? new Error("Cannot create date from " + JSON.stringify(t)) : new Error("Cannot create date from Function");
  } else
    return ce.now();
}), Pi = He((e) => {
  const t = Je(e[0], "date1 must be a date, e.g. created by DATE_CREATE"), r = Je(e[1], "date2 must be a date, e.g. created by DATE_CREATE"), u = e[2] ?? "day";
  return t.diff(r, u, !0);
}), Yi = He((e) => {
  const t = Je(e[0], "date1 must be a date, e.g. created by DATE_CREATE"), r = Je(e[1], "date2 must be a date, e.g. created by DATE_CREATE");
  return t.isBefore(r);
}), zi = He((e) => {
  const t = Je(e[0], "date1 must be a date, e.g. created by DATE_CREATE"), r = Je(e[1], "date2 must be a date, e.g. created by DATE_CREATE");
  return t.isAfter(r);
}), Vi = Ve("year"), Gi = Ve("month"), Wi = Ve("date"), qi = Ve("quarter"), Qi = Ve("hours"), Zi = Ve("minutes"), Ki = Ve("seconds"), Ji = Ve("unixTimestamp"), ze = {
  // Data
  VALUE: fr,
  COUNT: Ai,
  IS_EMPTY: vi,
  PAGE_VALIDATED: wi,
  PRODUCT_SELECTED: Bi,
  ALREADY_ORDERED: Si,
  PERSONS: _i,
  CURRENT_PERSON: Ti,
  // Math
  sqrt: Oi,
  sin: Ii,
  cos: Mi,
  tan: xi,
  abs: Ni,
  min: Ri,
  max: ki,
  floor: $i,
  ceil: Hi,
  round: Li,
  // Dates
  DATE_NOW: Ui,
  DATE_CREATE: ji,
  DATE_DIFF: Pi,
  DATE_IS_BEFORE: Yi,
  DATE_IS_AFTER: zi,
  DATE_YEAR: Vi,
  DATE_MONTH: Gi,
  DATE_DAY: Wi,
  DATE_QUARTER: qi,
  DATE_HOUR: Qi,
  DATE_MINUTE: Zi,
  DATE_SECOND: Ki,
  DATE_TIMESTAMP: Ji
}, dr = {};
for (let e in ze)
  ze.hasOwnProperty(e) && Object.defineProperty(dr, e, {
    value: ze[e],
    writable: !1
  });
const Xi = (e, t) => {
  if (e == "VALUE")
    throw new Error('Cannot override field function "VALUE"');
  ze[e] = t;
}, Jo = (e) => {
  if (dr[e] ?? !1)
    throw new Error('Cannot unregister built-in field function "' + e + '"');
  delete ze[e];
}, Xo = (e) => {
  const t = dr[e] ?? null;
  if (t)
    Xi(e, t);
  else
    throw new Error("Not a built-in function: " + e);
}, el = (e) => e - Math.floor(e) <= 0.5 ? Math.floor(e) : Math.ceil(e), tl = (e) => e - Math.floor(e) >= 0.5 ? Math.ceil(e) : Math.floor(e), rl = (e) => Math.ceil(e) - e == 0.5 ? e > 0 ? Math.floor(e) : Math.ceil(e) : Math.round(e), ul = (e) => Math.floor(e), nl = (e) => Math.ceil(e), ea = (e) => typeof e == "number" ? !0 : String(e).indexOf("e") > -1 ? !1 : !isNaN(e) && !isNaN(parseFloat(e));
var st = /* @__PURE__ */ ((e) => (e.NUMBER = "number", e.STRING = "string", e.BOOLEAN = "boolean", e.ARRAY = "array", e.NULL = "null", e.OPERATOR = "operator", e.FUNCTION = "function", e.ARGUMENT = "argument", e.INVALID = "invalid", e))(st || {});
class Z {
  constructor(t, r, u = []) {
    this.type = t, this.content = r, this.children = u;
  }
  getType() {
    return this.type;
  }
  getContent() {
    return this.content;
  }
  hasChildren() {
    return this.children.length > 0;
  }
  getChildren() {
    return this.children;
  }
  /**
   * Add a cild to this token
   *
   * @param {ExpressionToken} child
   *
   * @returns {this}
   */
  addChild(t) {
    return this.children.push(t), this;
  }
  /**
   * Get a specific child of this token
   *
   * @param {number} index -1 for last, else index
   *
   * @returns {ExpressionToken | null}
   */
  getChild(t) {
    return this.children.length < 1 ? null : t === -1 ? this.children[this.children.length - 1] : this.children[t] ?? null;
  }
  /**
   * Remove the last child
   *
   * @returns {ExpressionToken | null}
   */
  removeLastChild() {
    return this.children.pop() ?? null;
  }
  /**
   * Append to this token
   * Depending on the type, this may mean different things.
   * Strings will append to the content, everything else to its children
   *
   * @param {string|ExpressionToken} arg What to append
   *
   * @return this
   */
  append(t) {
    switch (this.type) {
      case "string":
        this.content += t;
        break;
      default:
        if (!(t instanceof Z))
          throw new Error('Cannot append "' + t + '" to token of type "' + this.type + '"');
        this.addChild(t);
    }
    return this;
  }
  push(t) {
    return this.append(t);
  }
  /**
   *  Pop from this token
   *  Depending on the type, this may mean different things.
   *  Strings will remove their last character, everything else will remove their last child
   */
  pop() {
    switch (this.type) {
      case "string":
        const t = this.content[this.content.length - 1];
        return this.content = this.content.substring(0, this.content.length - 1), t;
      default:
        return this.removeLastChild();
    }
  }
  toString() {
    return this.content;
  }
  // Convenience helpers
  static invalid(t) {
    return new Z("invalid", t);
  }
  static number(t) {
    return new Z("number", t);
  }
  static string(t) {
    return new Z("string", t);
  }
  static boolean(t) {
    return new Z("boolean", t);
  }
  static null(t) {
    return new Z("null", t);
  }
  static operator(t) {
    return new Z("operator", t);
  }
  static function(t) {
    return new Z("function", t);
  }
  static argument(t) {
    return new Z("argument", t);
  }
}
const ta = [
  ...Object.values(fe),
  ...Object.values(V),
  ...Object.values(xe),
  ...Object.values(se)
], nr = [
  `
`,
  "(",
  ")",
  " ",
  '"',
  "[",
  "]",
  ",",
  ...ta
], Be = {
  precedence: 5,
  associativity: "left"
}, sr = {
  [se.POWER]: {
    precedence: 0,
    associativity: "right"
  },
  [se.MULTIPLY]: {
    precedence: 2,
    associativity: "left"
  },
  [se.DIVIDE]: {
    precedence: 2,
    associativity: "left"
  },
  [se.ADD]: {
    precedence: 3,
    associativity: "left"
  },
  [se.SUBTRACT]: {
    precedence: 3,
    associativity: "left"
  },
  [V.EQUALS]: {
    precedence: 4,
    associativity: "left"
  },
  [fe.NOT_EQUALS]: {
    precedence: 4,
    associativity: "left"
  },
  [V.BEGINS_WITH]: Be,
  [fe.NOT_BEGINS_WITH]: Be,
  [V.ENDS_WITH]: Be,
  [fe.NOT_ENDS_WITH]: Be,
  [V.CONTAINS]: Be,
  [fe.NOT_CONTAINS]: Be,
  [V.LESS_THAN]: Be,
  [V.LESS_THAN_OR_EQUAL]: Be,
  [V.GREATER_THAN]: Be,
  [V.GREATER_THAN_OR_EQUAL]: Be,
  [xe.AND]: {
    precedence: 6,
    associativity: "right"
  },
  [xe.OR]: {
    precedence: 7,
    associativity: "right"
  }
}, ra = (e) => {
  e = String(e).trim(), e = e.replace("	", " ");
  const t = [];
  let r = "";
  for (; e.length > 0; ) {
    const u = ui(e, nr);
    if (u === !1) {
      r += e[0], e = e.substring(1);
      continue;
    }
    r !== "" && t.push(r), t.push(nr[u]), e = e.substring(nr[u].length), r = "";
  }
  return r !== "" && t.push(r), t;
}, ua = (e) => {
  const t = [], r = [];
  let u = "", n = [], i = null, s = null, o = {
    value: n
  };
  for (let l of e) {
    if (l !== '"' && s !== null) {
      s += l, u = l;
      continue;
    }
    switch (l) {
      case "(":
        if (u === " " || u == "")
          t.unshift(l);
        else {
          let c = Z.function(u);
          r.unshift(c), t.unshift(l), o.value.pop(), o.value.push(c), i = c, o.value = i;
        }
        u = l;
        break;
      case ")":
        if (r.shift(), i = r.length ? r[r.length - 1] : null, i ? o.value = i : o.value = n, t.length) {
          for (; t.length > 0 && (l = t.shift(), l != "("); )
            o.value.push(l);
          if (l != "(")
            throw new Error("Mismatched brackets");
        }
        u = l;
        break;
      case "[":
        u = l;
        break;
      case "]":
        u = l;
        break;
      case '"':
        s === null ? s = "" : ni(u, "\\") !== !1 ? s = s.substring(0, s.length - 1) + l : (Ie(o, Z.string(s)), s = null), u = l;
        break;
      case " ":
        u = l;
        break;
      case ",":
        if (i)
          break;
        Ie(o, Z.invalid(l));
        break;
      default:
        if (sr[l]) {
          for (; t.length; ) {
            let c = t[0];
            if (c instanceof Z && (c = c.getContent()), c == "(")
              break;
            const f = sr[l], p = f.precedence, m = sr[c].precedence;
            if (p < m || p == m && f.associativity == "right")
              break;
            {
              const N = t.shift();
              N instanceof Z ? Ie(o, N) : Ie(o, Z.operator(N));
            }
          }
          t.unshift(Z.operator(l));
        } else
          ea(l) ? Ie(o, Z.number(l)) : l == "true" || l == "false" ? Ie(o, Z.boolean(l)) : l == "null" ? Ie(o, Z.null(l)) : i ? Ie(o, Z.argument(l)) : Ie(o, Z.invalid(l));
        u = l;
    }
  }
  for (; t.length; ) {
    let l = t.shift();
    if (l != "(")
      o.value.push(l);
    else
      throw new Error("Mismatched brackets");
  }
  return o.value;
}, Ie = (e, t) => {
  e.value.push(t);
};
var na = /* @__PURE__ */ ((e) => (e.CONDITION = "condition", e.CONDITION_GROUP = "condition_group", e.TERM = "term", e))(na || {});
const sl = (e) => {
  const t = ua(ra(e)), r = la(t);
  return Da(r);
}, Fu = {
  [fe.NOT_EQUALS]: V.EQUALS,
  [fe.NOT_CONTAINS]: V.CONTAINS,
  [fe.NOT_ENDS_WITH]: V.ENDS_WITH,
  [fe.NOT_BEGINS_WITH]: V.BEGINS_WITH
}, sa = ou(Fu), ia = (e) => e !== null && typeof e == "object" && e.type == "condition", aa = (e) => e !== null && typeof e == "object" && e.type == "condition_group", oa = (e) => e !== null && typeof e == "object" && e.type == "term", la = (e) => {
  const t = [], r = e.length;
  let u = 0;
  for (; u < r; ) {
    let n = e[u++], i, s;
    if (n.getType() == st.OPERATOR)
      switch (n.getContent()) {
        case V.GREATER_THAN_OR_EQUAL:
        case V.GREATER_THAN:
        case V.LESS_THAN_OR_EQUAL:
        case V.LESS_THAN:
        case V.EQUALS:
        case V.BEGINS_WITH:
        case V.ENDS_WITH:
        case V.CONTAINS:
          s = t.pop(), i = t.pop(), t.push({
            type: "condition",
            operator: n,
            left: i,
            right: s
          });
          break;
        case se.ADD:
        case se.SUBTRACT:
        case se.DIVIDE:
        case se.MULTIPLY:
        case se.POWER:
          s = t.pop(), i = t.pop(), t.push({
            type: "term",
            operator: n,
            left: i,
            right: s
          });
          break;
        case fe.NOT_EQUALS:
        case fe.NOT_CONTAINS:
        case fe.NOT_BEGINS_WITH:
        case fe.NOT_ENDS_WITH:
          s = t.pop(), i = t.pop(), t.push({
            type: "condition",
            operator: Z.operator(Fu[n.getContent()]) ?? n.getContent(),
            left: i,
            right: s,
            negated: !0
          });
          break;
        case xe.AND:
        case xe.OR:
          s = t.pop(), i = t.pop(), t.push({
            type: "condition_group",
            operator: n,
            conditions: [i, s]
          });
          break;
        default:
          t.push(n);
      }
    else
      t.push(n);
  }
  return t.length ? t[0] : [];
}, Da = (e) => Ze(e), Xr = (e) => e.map((t) => Ze(t)), Ze = (e) => {
  if (e instanceof Z)
    return e.getType() == st.FUNCTION ? Ei(e.getContent(), Xr(e.getChildren())) : e.getType() == st.ARRAY ? Pe(Xr(e.getChildren())) : e.getType() == st.NUMBER ? Pe(Number(e.getContent())) : e.getType() == st.BOOLEAN ? Pe(e.getContent() == "true") : Pe(e.getContent());
  if (e === null)
    return Pe(null);
  if (typeof e == "object") {
    if (ia(e))
      return wt({
        type: "condition",
        left: Ze(e.left),
        right: Ze(e.right),
        operator: e.operator.getContent(),
        negated: e.negated ?? !1
      });
    if (aa(e))
      return wt({
        type: "condition_group",
        operator: e.operator.getContent(),
        children: e.conditions.map(Ze)
      });
    if (oa(e))
      return wt({
        type: "term",
        operator: e.operator.getContent(),
        fields: [
          Ze(e.left),
          Ze(e.right)
        ]
      });
    throw new Error("Unknown expression token: " + JSON.stringify(e));
  } else
    return Pe(e);
}, ca = (e, t = !1) => Ue(e, t), Ue = (e, t = !1, r = 0) => {
  const u = "	".repeat(r), n = "	".repeat(r + 1);
  if (gt(e))
    switch (e.type) {
      case pe.BOOLEAN:
        return e.content ? "true" : "false";
      case pe.NUMBER:
        return String(e.content);
      case pe.STRING:
        return '"' + String(e.content) + '"';
      case pe.NULL:
        return "null";
      default:
        throw new Error('Unknown data type "' + e.type + '"');
    }
  else if (ke(e)) {
    const i = e.children.map((s) => Ue(typeof s != "object" ? Pe(s) : s, t, r + 1)).join(", ");
    return `${String(e.name)}(${i})`;
  } else {
    if (lr(e))
      return "[ TODO ]";
    if (me(e)) {
      const i = e.negated ? sa[e.operator] : e.operator, s = Ue(e.left, t, r + 1), o = Ue(e.right, t, r + 1);
      return t ? u + `(
` + n + s + `
` + n + i + `
` + n + o + `
` + u + ")" : `(${s} ${i} ${o})`;
    } else if (ge(e))
      if (t) {
        const i = e.children.map((s) => Ue(s, t, r + 1)).join(`
` + n + e.operator + `
`);
        return u + `(
` + i + `
` + u + ")";
      } else
        return `(${e.children.map((s) => Ue(s, t, r + 1)).join(` ${e.operator} `)})`;
    else if (Re(e))
      return `(${e.fields.map((s) => Ue(s, t, r + 1)).join(` ${e.operator} `)})`;
  }
  return "";
}, mu = Fe("lib/expressions/evaluation", Fe.COLOR_HELPER), $e = (e, t) => {
  if (ge(e))
    return fa(e, t);
  if (me(e)) {
    let r = Ke(e.left, t), u = Ke(e.right, t), n = String(r).toLocaleLowerCase(), i = String(u).toLocaleLowerCase(), s = !0;
    return pt[e.operator] && (s = pt[e.operator](
      {
        value: r,
        string: n
      },
      {
        value: u,
        string: i
      }
    )), e.negated && (s = !s), s;
  } else return Re(e) ? Ut(e, t) > 0 : gt(e) || ke(e) ? Ke(e, t) : !1;
}, fa = (e, t) => {
  var r;
  if (!((r = e.children) != null && r.length))
    return !1;
  for (let u of e.children)
    if ($e(u, t)) {
      if (e.operator == xe.OR)
        return !0;
    } else if (e.operator == xe.AND)
      return !1;
  return e.operator == xe.AND;
}, Ut = (e, t) => {
  if (me(e) || ge(e))
    return Number($e(e, t));
  if (ke(e))
    return Number(Ke(e, t));
  if (!Re(e))
    return 0;
  let r = e.fields.map((n) => Re(n) ? { value: Ut(n, t) } : me(n) || ge(n) ? { value: Number($e(n, t)) } : { value: Number(Ke(n, t)) }), u = pt[e.operator];
  if (u)
    return u(r);
  {
    let n = new Error("Unknown operator: " + e.operator);
    return mu.always.warn(n.message), lu().send(n, [], e), 0;
  }
}, Ke = (e, t) => {
  var r;
  if (me(e) || ge(e))
    return $e(e, t);
  if (Re(e))
    return Ut(e, t);
  if (ke(e)) {
    let u = (r = ze[e.name]) == null ? void 0 : r.evaluate;
    if (u) {
      let n = e.children.map((s) => Re(s) ? Ut(s, t) : me(s) || ge(s) ? $e(s, t) : Ke(s, t)), i = u(n, t);
      return mu.debugFrom("parseExpressionField", ca(e), "as", e.name, "(", n, ")", "=>", i), i;
    } else {
      let n = new Error('Function "' + e.name + '" does not exist');
      return console.warn("[Expressions]", n.message), lu().send(n, [], { field: e }), 0;
    }
  } else return lr(e) ? e.children.map((u) => Ke(u, t)) : gt(e) ? e.content : typeof e == "string" || typeof e == "number" || typeof e == "boolean" ? e : Pe(null);
}, il = (e, t, r = !1, u = { default: [] }, n) => {
  const i = Array.isArray(u) ? {
    default: u
  } : u;
  let s = {
    tag: e,
    tag_normalized: zt(e),
    properties: t,
    required: r,
    children: i,
    hidden: !1,
    disabled: !1,
    validated: !1,
    linked: [],
    validation_linked: [],
    display_condition: null,
    disabled_condition: null
  };
  if (Me([s]), n) {
    const o = n(s);
    if (o)
      return o;
  }
  return s;
}, Me = (e, t = !1) => e.map((r) => gu(r, t)), gu = (e, t = !1) => {
  var r;
  switch (e.tag.substring(0, 7) == "adepto-" && (e.tag = "acquisit-" + e.tag.substring(7)), e.properties || (e.properties = {}), e.properties.uid === void 0 && (e.properties.uid = Yt("ui-")), e.tag_normalized = zt(e.tag), (t || !tr(e.validated)) && (e.validated = !1), e.properties.value !== void 0 ? (e.properties.modelValue = e.properties.value, delete e.properties.value) : e.properties.modelValue === void 0 && (e.properties.modelValue = null), tr(e.properties.semantic) && !Array.isArray(e.properties.semantic) && (e.properties.semantic = [String(e.properties.semantic)]), e.properties.errors = null, e.display_condition = e.display_condition ?? null, e.disabled_condition = e.disabled_condition ?? null, e.tag_normalized) {
    case "items-editor":
    case "items-input":
      if (Array.isArray(e.properties.items))
        for (let u of e.properties.items)
          Me(u.components, t);
      if (Array.isArray(e.properties.modelValue))
        for (let u of e.properties.modelValue)
          Me(u.components, t);
      break;
    case "persons-editor":
      Array.isArray(e.properties.additional_components) ? Me(e.properties.additional_components) : e.properties.additional_components = null;
      break;
    case "persons-layout":
      e.properties.components || (e.properties.components = []), Me(e.properties.components, t), typeof e.properties.modelValue == "object" && Se(e.properties.modelValue, (u) => {
        Me(u.components, t);
      });
      break;
    case "input":
      if (e.properties.regex)
        try {
          new RegExp(e.properties.regex);
        } catch {
          throw new Error("Invalid regular expression for " + e.properties.uid + ": " + e.properties.regex);
        }
      break;
    case "viewfinder-image-input":
      (r = e.properties.image_metadata) != null && r.components && Me(e.properties.image_metadata.components);
      break;
  }
  return Array.isArray(e.children) ? e.children = {
    default: e.children
  } : tr(e.children) || (e.children = {
    default: []
  }), Xe(e) && Se(e.children, (u) => {
    Me(u, t);
  }), e;
}, al = (e, t = !1) => gu(Ne(e), t), ol = (e, t = !1) => Me(Ne(e), t), ll = (e) => !!(e != null && e.properties && (e != null && e.tag)), zt = (e) => String(e).replace(/([a-z\d]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase().split("-").filter((t) => !!t && t != "adepto" && t != "acquisit").join("-"), Ae = (e) => {
  let t = [];
  if (Array.isArray(e))
    for (let r of e)
      t = t.concat(Ae(r));
  else if (typeof e == "object") {
    if (at(e) || Lt(e))
      t.push(e);
    else
      for (let r in e)
        if (e.hasOwnProperty(r)) {
          let u = e[r];
          Lt(u) || at(u) ? t.push(u) : t = t.concat(Ae(u));
        }
  }
  return t;
}, Xe = (e) => {
  if (!e.children || !$t(e.children))
    return !1;
  for (let t in e.children)
    if (e.children.hasOwnProperty(t) && e.children[t].length)
      return !0;
  return !1;
}, da = (e, t, r = "OR") => {
  if (!e.properties.semantic)
    return !1;
  let u = typeof e.properties.semantic == "string" ? [e.properties.semantic] : e.properties.semantic;
  return ri(u, t, r);
}, ha = (e, t) => {
  hr(e, (r, u) => {
    for (let n of r)
      t(n, u);
  });
}, hr = (e, t) => {
  Se(e.children, t);
}, pa = async (e, t) => Ys(e.children, t), pr = (e, t) => {
  for (let r of e.properties.rows)
    for (let u of r)
      t(u);
}, Fa = async (e, t) => {
  for (let r of e.properties.rows)
    for (let u of r)
      await t(u);
}, jt = (e, t, r = !0) => {
  const u = Array.isArray(e) ? e : Ae(e);
  for (let n of u) {
    if (t(u, n) === !1)
      break;
    r && (Pt(n) && pr(n, (i) => {
      jt(i, t);
    }), Xe(n) && hr(n, (i) => {
      jt(i, t);
    }));
  }
}, eu = async (e, t, r = !0) => {
  const u = Array.isArray(e) ? e : Ae(e), n = [];
  for (let i of u) {
    if (await t(u, i) === !1)
      break;
    r && (Pt(i) && n.push(Fa(i, async (s) => {
      await eu(s, t);
    })), Xe(i) && n.push(pa(i, async (s) => {
      await eu(s, t);
    })));
  }
  await Promise.all(n);
}, Fr = (e) => {
  let t = {};
  return jt(e, (r, u) => {
    t[u.properties.uid] = u;
  }, !0), t;
}, Cu = (e, t = !1) => {
  let r = {}, u = {};
  const n = (s) => {
    s.tag_normalized in r || (r[s.tag_normalized] = []), u[s.properties.uid] || (r[s.tag_normalized].push(s), u[s.properties.uid] = !0);
  }, i = (s) => {
    for (let o of s)
      n(o);
  };
  e = Array.isArray(e) ? e : Ae(e);
  for (let s of e)
    n(s), Xe(s) && (at(s), tu(s), (!t || at(s) && tu(s)) && hr(s, (o, l) => {
      const c = Cu(o, t);
      Se(c, (f) => {
        i(f);
      });
    }));
  return r;
}, Dl = (e) => {
  let t = {};
  return jt(e, (r, u) => {
    t[u.tag_normalized] || (t[u.tag_normalized] = {}), t[u.tag_normalized][u.properties.uid] = u;
  }, !1), t;
}, cl = (e) => {
  const t = [];
  return ha(e, (r) => t.push(r)), t;
}, fl = (e) => {
  let t = [];
  return pr(e, (r) => {
    t = t.concat(r);
  }), t;
}, or = (e, t) => {
  const r = Array.isArray(e) ? e : Ae(e);
  for (let u of r) {
    if (typeof t == "function" && t(u) || u.properties.uid == t)
      return u;
    if (Pt(u))
      for (let n of u.properties.rows)
        for (let i of n) {
          let s = or(i, t);
          if (s)
            return s;
        }
    else if (u.children) {
      let n = or(u.children, t);
      if (n)
        return n;
    }
  }
  return null;
}, dl = (e, t, r = "OR") => or(e, (u) => da(u, t, r)), nt = (e, t, r) => {
  const u = Ae(e);
  if (!t.length || !u.length)
    return 0;
  let n = 0, i = Jr(t);
  for (let s of u)
    Ws(s) && (Jr(s.properties.path) == i && (n += 1), Array.isArray(s.properties.components) && (n += nt(s.properties.components, t)), Array.isArray(s.properties.image_metadata_components) && (n += nt(s.properties.image_metadata_components, t)), Array.isArray(s.properties.additional_components) && (n += nt(s.properties.additional_components, t)), typeof s.properties.items == "object" && Se(s.properties.items ?? {}, (o) => {
      n += nt(o, t);
    }), Pt(s) && pr(s, (o) => {
      n += nt(o, t);
    }), r && (n += r(s, t))), s.children && (n += nt(s.children, t));
  return n;
}, hl = (e) => (e || "").replace(/[^ADLS+]/g, ""), pl = (e, t) => {
  const r = new RegExp(`[^\\dA-Za-zäöüßÄÖÜæœåÆŒÅéèÉÈ${(t || "").indexOf("S") > -1 ? " " : ""}]`, "g");
  return (e || "").replace(r, "");
}, Fl = (e, t) => {
  Se(t, (r, u) => {
    e.properties[u] = r;
  });
}, ml = (e, t) => {
  const r = {
    uid: Yt("item-"),
    title: void 0,
    title_reference_uid: void 0,
    icon: null,
    components: e,
    image_collections: null,
    add_collection_label: void 0,
    hidden: !1,
    allows_deletion: !0
  };
  if (t) {
    const u = t(r);
    if (u)
      return u;
  }
  return r;
}, gl = (e, t) => {
  const r = {
    id: Yt("collection-"),
    hash_id: null,
    title: null,
    title_label: void 0,
    description: null,
    image_description_label: void 0,
    images: [],
    add_image_label: e,
    required: !1,
    error: null,
    deleted: !1
  };
  if (t) {
    const u = t(r);
    if (u)
      return u;
  }
  return r;
}, Cl = (...e) => {
  for (let t of e)
    for (let r of e)
      t.properties.uid != r.properties.uid && (Array.isArray(t.linked) || (t.linked = []), t.linked.push(r.properties.uid));
  return e;
}, El = (e, t) => mr({
  tag: e,
  tag_normalized: zt(e),
  properties: t
}), yl = (e, t = {}) => mr({
  tag: "reference",
  properties: {
    ...t,
    path: e
  }
}), bl = (e) => ({
  type: mt.COMPONENT,
  uid: e
}), Al = (e) => ({
  type: mt.ITEM,
  uid: e
}), vl = () => ({
  type: mt.METADATA,
  uid: ""
}), wl = (e = "") => ({
  type: mt.PERSON,
  uid: e
}), Bl = (e, t) => ({
  type: e,
  uid: t
}), Sl = (e, t, r) => {
  for (let u of e)
    u.uid == t && (u.uid = r);
}, mr = (e) => (e.properties.uid || (e.properties.uid = Yt("pdf-")), e.tag_normalized || (e.tag_normalized = zt(e.tag)), e.children || (e.children = {}), e.children.default || (e.children.default = []), e.pdf || (e.pdf = !0), e), _l = (e) => {
  for (let t of e)
    mr(t);
}, Tl = (e, t = !1) => {
  let r = e;
  return t && (r = Ne(r)), r = zs(r, ["properties", "tag", "tag_normalized", "children", "display_condition"]), r.children.default = [], delete r.properties.errors, r.pdf = !0, r;
}, ma = (e, t, r) => {
  let u = (n, i = []) => {
    i = Ne(i);
    for (let s of n) {
      if (s.properties.uid == e.properties.uid)
        return e.hidden ? [] : e.display_condition && !$e(e.display_condition, r) ? [] : (i.push(e.properties.uid), i);
      if (s.tag == "input" && s.properties.type == "data")
        return [];
      if ((!!s.properties.modelValue || Eu(s)) && Xe(s)) {
        i.push(s.properties.uid);
        let l = u(Ae(s.children), i);
        if (l.length)
          return l;
      }
    }
    return [];
  };
  return u(t.components).length > 0;
}, Ol = (e, t) => e.properties.disabled || e.disabled ? !0 : me(e.disabled_condition) || ge(e.disabled_condition) ? $e(e.disabled_condition, t) : !1, tu = (e, t) => {
  if (Eu(e))
    return !0;
  const r = e.properties;
  let u = r.disabled ?? !1;
  switch (t && e.disabled_condition && (u = $e(e.disabled_condition, t)), e.tag_normalized) {
    case "checkbox":
      return (r.childrenHiddenWhenDisabled ?? !0) && u ? !1 : !!r.modelValue != !!r.childrenInverted;
    default:
      return !!e.properties.modelValue;
  }
}, Il = (e) => {
  if (!e)
    throw new Error("Cannot focus component null");
  const t = {
    "acquisit-persons"() {
      let u = e.querySelector(".edit-person-button:first-of-type");
      u && u.focus();
    },
    "acquisit-checkbox"() {
      let u = e.querySelector(".checkbox-wrapper");
      u && u.focus();
    },
    "acquisit-persons-address"() {
      let u = e.querySelector(".acquisit-input:first-of-type input");
      u && u.focus();
    },
    "acquisit-input"() {
      let u = e.querySelector("input");
      u && u.focus();
    },
    "acquisit-textarea"() {
      let u = e.querySelector("textarea");
      u && u.focus();
    },
    default() {
      e.focus();
    }
  };
  let r = !1;
  for (let u in t)
    if (t.hasOwnProperty(u) && e.classList.contains(u)) {
      t[u](), r = !0;
      break;
    }
  r || t.default();
}, Eu = (e) => ga[e.tag_normalized] === !0, ga = {
  "accordion-item": !0,
  "checkbox-group": !0,
  "container-layout": !0,
  "horizontal-layout": !0
}, yu = {
  checkbox: !0,
  "country-chooser": !0,
  input: !0,
  textarea: !0,
  comment: !0,
  "image-input": !0,
  dropdown: !0,
  "math-label": !0,
  "persons-chooser": !0,
  "product-person-chooser-address": !0,
  // Only used internally
  stepper: !0
};
var Ca = /* @__PURE__ */ ((e) => (e.V2_1 = "2.1", e.V3_0 = "3.0", e))(Ca || {});
const Ft = ({ componentsByUID: e, productsByUID: t, personsByID: r }, u = !0, n = "2.1") => {
  let i = {}, s = Cu(Object.values(e), !0), o = Object.keys(yu);
  for (let H of o) {
    let x = s[H];
    if (Array.isArray(x)) {
      for (let R of x)
        if (R.validated || !u) {
          if (R.hidden)
            continue;
          R.tag_normalized == "input" && R.properties.format == "number" ? i[R.properties.uid] = R.properties.modelValue ? Du(R.properties.modelValue) : null : i[R.properties.uid] = R.properties.modelValue;
        }
    }
  }
  let l = (s["single-product-chooser-carousel"] || []).concat(s["single-product-chooser-list"] || []).concat(s["multi-product-chooser"] || []);
  i = je(i, ya(l, t, u));
  let c = s["product-person-chooser"] || [];
  i = je(i, ba(c, u));
  let f = (s["items-input"] || []).concat(s["items-editor"] || []), p = Au(f, r, t, u, n), m = p.items;
  i = je(i, p.values);
  let N = s["persons-layout"] || [];
  i = je(i, Ea(N, r, t, u, n));
  let _ = s["persons-editor"] || [];
  if (_.length) {
    const H = _[_.length - 1];
    i = je(i, Aa(H, r, t, u, n));
  }
  let b = s["image-input"] || [], F = vu(b, u, n), v = s["viewfinder-image-input"] || [], I = wu(v, r, t, u, n), B = {
    values: i
  };
  return ($t(F) || $t(I)) && (B.images = je(F, I)), $t(m) && (B.items = m), B;
}, bu = (e, t, r, u = !0, n = "2.1") => {
  let i = {}, s = !1;
  const o = Ae(e);
  for (let l of o)
    if (!l.hidden) {
      if (l.tag_normalized == "persons-layout")
        i[l.properties.uid] = Bu(l, t, r, u, n);
      else if (l.tag_normalized == "items-input" || l.tag_normalized == "items-editor") {
        let c = Au([l], t, r, u, n).items;
        i[l.properties.uid] = c[l.properties.uid] || null;
      } else if (l.tag_normalized == "image-input") {
        let c = vu([l], u, n).images;
        i[l.properties.uid] = c || {};
      } else if (l.tag_normalized == "viewfinder-image-input") {
        let c = wu([l], t, r, u, n).images;
        i[l.properties.uid] = c || {};
      } else l.properties.format == "number" ? i[l.properties.uid] = Du(l.properties.modelValue || "") : yu[l.tag_normalized] && (i[l.properties.uid] = l.properties.modelValue);
      if (l.properties.type != "data" && l.properties.modelValue !== void 0 && l.properties.modelValue !== null && l.properties.modelValue !== "" && (s = !0), Xe(l) && !(l.tag_normalized == "checkbox" && !l.properties.modelValue)) {
        let c = bu(l.children, t, r, u, n);
        i = je(i, c.values), c.hasAnyValue && (s = !0);
      }
    }
  return {
    values: i,
    hasAnyValue: s
  };
}, Au = (e, t, r, u = !0, n = "2.1") => {
  var o;
  let i = {}, s = {};
  for (let l of e) {
    if (u && !l.validated) continue;
    let c = l.properties.uid, f = l.properties.modelValue || [];
    if (f.length)
      for (let p of f) {
        let m = bu(p.components, t, r, u, n);
        if (m.hasAnyValue && p.image_collections && p.image_collections.length)
          for (let N of p.image_collections)
            for (let _ of N.images)
              "images" in m.values || (m.values.images = []), n == "3.0" ? m.values.images.push({
                hash_id: _.hash_id,
                url: _.url
              }) : m.values.images.push(_.hash_id);
        m.hasAnyValue ? (c in i || (i[c] = []), i[c].push(m.values), n == "3.0" ? (m.values.__itemUID = p.uid, p.template_uid ? m.values.__itemTemplateUID = p.template_uid : m.values.__itemTemplateUID = p.uid, Array.isArray(s[c]) || (s[c] = []), s[c].push(m.values)) : s[c] = !0) : n == "3.0" ? s[c] = [] : s[c] = !1;
      }
    else (o = l.properties.no_items_checkbox) != null && o.value && (s[c] = !1);
  }
  return {
    items: i,
    values: s
  };
}, vu = (e, t = !0, r = "2.1") => {
  let u = {}, n = {};
  for (let i of e)
    if (!t || i.validated) {
      let s = i.properties.uid;
      s in u || (u[s] = []), u[s].push(i.properties.modelValue || []);
    }
  for (let i in u)
    if (u.hasOwnProperty(i)) {
      n[i] = [];
      for (let s of u[i])
        for (let o of s)
          for (let l of o.images)
            (l.hash_id || !t) && (r == "3.0" ? n[i].push({
              hash_id: l.hash_id,
              url: l.url
            }) : n[i].push(l.hash_id));
      n[i].length || delete n[i];
    }
  return n;
}, wu = (e, t, r, u = !0, n = "2.1") => {
  let i = {};
  for (let s of e)
    if (!u || s.validated) {
      let o = s.properties.uid;
      if (o in i || (i[o] = []), Array.isArray(s.properties.modelValue) && s.properties.modelValue.length)
        for (let l of s.properties.modelValue)
          n == "3.0" ? i[o].push({
            hash_id: l.hash_id,
            url: l.url,
            metadata: l.metadata ? Ft({
              componentsByUID: l.metadata,
              productsByUID: r,
              personsByID: t
            }, u, n) : []
          }) : i[o].push(l.hash_id);
    }
  return i;
}, Ml = (e) => e.map((t) => ({
  hash_id: t.hash_id,
  title: t.title,
  description: t.description,
  images: t.images.map((r) => ({
    hash_id: r.hash_id,
    url: r.url,
    title: r.title
  }))
})), Ea = (e, t, r, u = !0, n = "2.1") => {
  let i = {};
  for (let s of e)
    u && !s.validated || (i[s.properties.uid] = Bu(s, t, r, u, n));
  return i;
}, ya = (e, t, r = !0) => {
  let u = {};
  for (let n of e)
    r && !n.validated || (u[n.properties.uid] = va(n, t));
  return u;
}, ba = (e, t = !0) => {
  let r = {};
  for (let u of e)
    t && !u.validated || (r[u.properties.uid] = wa(u));
  return r;
}, Aa = (e, t, r, u = !0, n = "2.1") => {
  let i = {}, s = e.properties.types ?? {};
  return Se(t, (o) => {
    var l;
    s[o.type] && ((l = o.additional_components) != null && l.length) && (i[o.id] = Ft({
      componentsByUID: Fr(o.additional_components),
      personsByID: t,
      productsByUID: r
    }, u, n));
  }), i;
}, Bu = (e, t, r, u = !0, n = "2.1") => {
  let i = {}, s = e.properties.modelValue;
  for (let o in s)
    if (s.hasOwnProperty(o)) {
      let l = s[o].components || s[o];
      i[o] = Ft({
        componentsByUID: Fr(l),
        personsByID: t,
        productsByUID: r
      }, u, n);
    }
  return i;
}, va = (e, t) => e.properties.declined ? !1 : Array.isArray(e.properties.modelValue) ? e.properties.modelValue.map((r) => {
  var u;
  return ((u = t[r]) == null ? void 0 : u.product_id) ?? r;
}) : null, wa = (e) => {
  if (!e.properties.modelValue)
    return null;
  let t = {}, r = e.properties.modelValue;
  for (let u of e.properties.component_uids || []) {
    let n = {};
    e.properties.role_buyer_label && (n.buyer_person_id = r.selected_buyer_id, e.properties.billing_address_label && (n.buyer_billing_address = Ne(r.billing_addresses[r.selected_buyer_id]))), e.properties.role_seller_label && (n.seller_person_id = r.selected_seller_id, e.properties.billing_address_label && (n.seller_billing_address = Ne(r.billing_addresses[r.selected_seller_id]))), t[u] = n;
  }
  return t;
};
export {
  yl as $,
  ll as A,
  zt as B,
  Ae as C,
  Xe as D,
  da as E,
  ha as F,
  hr as G,
  pa as H,
  pr as I,
  Fa as J,
  jt as K,
  eu as L,
  Fr as M,
  Cu as N,
  Dl as O,
  cl as P,
  fl as Q,
  or as R,
  dl as S,
  nt as T,
  hl as U,
  pl as V,
  Fl as W,
  ml as X,
  gl as Y,
  Cl as Z,
  El as _,
  Zs as a,
  au as a$,
  bl as a0,
  Al as a1,
  vl as a2,
  wl as a3,
  Bl as a4,
  Sl as a5,
  mr as a6,
  _l as a7,
  Tl as a8,
  ma as a9,
  ja as aA,
  Pa as aB,
  Kn as aC,
  Jn as aD,
  el as aE,
  tl as aF,
  rl as aG,
  ul as aH,
  nl as aI,
  ea as aJ,
  Ps as aK,
  Kr as aL,
  Ga as aM,
  Wa as aN,
  qa as aO,
  Qa as aP,
  Se as aQ,
  Ys as aR,
  rr as aS,
  ar as aT,
  Za as aU,
  je as aV,
  Ka as aW,
  Ja as aX,
  Xa as aY,
  $t as aZ,
  Ye as a_,
  Ol as aa,
  tu as ab,
  Il as ac,
  Eu as ad,
  Ta as ae,
  Oa as af,
  Ia as ag,
  Ma as ah,
  Hr as ai,
  xa as aj,
  Wn as ak,
  wt as al,
  uu as am,
  tr as an,
  Ne as ao,
  Na as ap,
  qn as aq,
  Qn as ar,
  Ra as as,
  ka as at,
  $a as au,
  nu as av,
  Ha as aw,
  La as ax,
  Zn as ay,
  Ua as az,
  lo as b,
  Li as b$,
  zs as b0,
  eo as b1,
  ou as b2,
  to as b3,
  Yt as b4,
  yo as b5,
  bo as b6,
  Ao as b7,
  Du as b8,
  vo as b9,
  yi as bA,
  cr as bB,
  bi as bC,
  Zo as bD,
  ot as bE,
  du as bF,
  hu as bG,
  pu as bH,
  He as bI,
  fr as bJ,
  Ai as bK,
  vi as bL,
  wi as bM,
  Bi as bN,
  Si as bO,
  _i as bP,
  Ti as bQ,
  Ko as bR,
  Oi as bS,
  Ii as bT,
  Mi as bU,
  xi as bV,
  Ni as bW,
  Ri as bX,
  ki as bY,
  $i as bZ,
  Hi as b_,
  wo as ba,
  Bo as bb,
  So as bc,
  _o as bd,
  To as be,
  Oo as bf,
  Io as bg,
  Mo as bh,
  xo as bi,
  No as bj,
  Ro as bk,
  ko as bl,
  $o as bm,
  Ho as bn,
  Lo as bo,
  Uo as bp,
  jo as bq,
  Po as br,
  ui as bs,
  ni as bt,
  Yo as bu,
  $e as bv,
  fa as bw,
  Ut as bx,
  Ke as by,
  Qo as bz,
  Do as c,
  it as c$,
  ze as c0,
  dr as c1,
  Xi as c2,
  Jo as c3,
  Xo as c4,
  zo as c5,
  gi as c6,
  Ci as c7,
  Vo as c8,
  Go as c9,
  Re as cA,
  ke as cB,
  lr as cC,
  gt as cD,
  na as cE,
  sl as cF,
  Fu as cG,
  sa as cH,
  la as cI,
  Da as cJ,
  st as cK,
  Z as cL,
  ra as cM,
  ua as cN,
  ca as cO,
  Lr as cP,
  za as cQ,
  Va as cR,
  E as cS,
  he as cT,
  Fe as cU,
  Gs as cV,
  Xn as cW,
  ro as cX,
  ce as cY,
  Ya as cZ,
  ir as c_,
  Ei as ca,
  Pe as cb,
  Wo as cc,
  qo as cd,
  ft as ce,
  si as cf,
  ii as cg,
  ai as ch,
  oi as ci,
  li as cj,
  Di as ck,
  ci as cl,
  fi as cm,
  di as cn,
  hi as co,
  pi as cp,
  Fi as cq,
  mi as cr,
  pt as cs,
  pe as ct,
  V as cu,
  fe as cv,
  xe as cw,
  se as cx,
  me as cy,
  ge as cz,
  Ks as d,
  lu as d0,
  Ca as d1,
  Ft as d2,
  Au as d3,
  vu as d4,
  wu as d5,
  Ml as d6,
  Ea as d7,
  ya as d8,
  ba as d9,
  Aa as da,
  at as db,
  uo as dc,
  no as dd,
  so as de,
  Lt as df,
  Ws as dg,
  Pt as dh,
  mt as di,
  Jr as dj,
  io as dk,
  Vs as dl,
  Js as e,
  co as f,
  ho as g,
  po as h,
  ao as i,
  Xs as j,
  mo as k,
  Co as l,
  Fo as m,
  ei as n,
  ti as o,
  Qs as p,
  Eo as q,
  oo as r,
  fo as s,
  ri as t,
  go as u,
  il as v,
  Me as w,
  gu as x,
  al as y,
  ol as z
};
//# sourceMappingURL=value-extraction-C_fDiBaZ.js.map
